import React, { useState, useEffect, useRef } from 'react';
import { styled } from '@mui/material/styles';
import '../../../../../../assets/css/stylesheet.css';
import '../assets/css/athleteProfileFinalDark.scss';
import '../../../../../../assets/css/owl.carousel.min.css';
import 'owl.carousel/dist/owl.carousel.js';
import 'owl.carousel/dist/owl.carousel.min.js';
import MetricsCarousel from './MetricsCarousel';
import { Avatar, Tooltip } from '@mui/material';
import ProfilePicCarousel from './ProfilePicCarousel';
import { useHistory, useLocation } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import GoTopButton from '../../editUserProfile/GoTopButton';
import {
  getAuthToken,
  getUserInfo,
} from '../../../../../../services/authService';
import ProfileTabs from './ProfileTabs';
import { athleteProfileDataStart } from '../../../../../../redux/athlete/profile/athleteProfileData';
import { imageDownloadUrl } from '../../../../../../config';
import Dialog from '@mui/material/Dialog';
import VerificationModal from '../../editUserProfile/VerificationModal';
import VerifiedShieldModal from '../../VerifiedModal';
import { getAllMembershipsQuery } from '../../account/myAccounts/membershipQuery';
import { allCheckListDataStart } from '../../../../../../redux/common/allCheckListData';
import { allProfileCalculationListStart } from '../../../../../../redux/common/allProfileCalculationMaster';
import SharePost from '../../homepage/posts/SharePost';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';
import X from '../assets/img/x-icon.png';
import InstagramIcon from '../assets/img/Instagram_Logo.png';
import MuiDialogContent from '@mui/material/DialogContent';
import {
  getAllAthletesDataQuery,
  getAllCheckListDataQuery,
  getAllCountriesQuery,
  getProfileCalculationListQuery,
} from '../../../../../common/CommonQuery';
import {
  athleteFollowApi,
  visitorViewCount,
} from '../../../../../common/userViewCount';
import { fetchMethod } from '../../../../../../services/httpService';
import { matchotpStart } from '../../../../../../redux/auth/signup/matchOtp';
import AreYouSure from '../../../../auth/claimProfile/claimProfileStep2/AreYouSure';
import { WebForm } from './webForm';
import { countryListStart } from '../../../../../../redux/common/countriesList';
import { athletesDetailsStart } from '../../../../../../redux/common/athletesDetails';
import { fetchGraphMethod } from '../../../../../../services/httpService';
import { checkAccountStatus } from './profileQuery';
import MuiAutoComplete from '../../../../../common/AutoComplete';
import TeamLogo from '../../../../../../assets/img/TeamLogo.png';
import { VideoPop } from '../../../../landingPage/common/videoPopup';
import { getThumbnail, typeConvert } from '../../../../../common/thumbnail';
import { getCamelCase } from '../../../../../common/camelCaseFunc';
import refresh from '../assets/img/refresh-icon.png';
import PhoneNumber from '../../../../../common/PhoneNumber';
import {
  checkPhoneNumberValidation,
  formatPhoneNumber,
  IsValidEmail,
  IsValidName,
} from '../../../../../../utils/validationUtils';
import { vidCountIncre } from '../../../../../common/userViewCount';
import { ClaimProfilePop } from './ClaimProfile';
import {
  getAthleteSysID,
  profileURLData,
} from '../../../../../common/getProfileURLData';
import DashboardHeader from '../../../../../layouts/header/DashboardHeader';
import ClaimProfileHeader from '../../../../auth/claimProfile/claimProfileStep1/ClaimProfileHeader';
import { PlatformImg } from '../../../../../../constants';
import { addSpaceToPascalCase } from '../../../../../../utils/addSpaceToPascalCase';
import { useMediaQuery } from '@mui/material';

const PREFIX = 'DarkEditProfile';

const classes = {
  root: `${PREFIX}-root`,
};

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.root}`]: {
    padding: theme.spacing(2),
  },
}));

const DialogContent = MuiDialogContent;

const DarkEditProfile = (props) => {
  const isMobile = useMediaQuery('(max-width:600px)');
  const history = useHistory(),
    location = useLocation();
  const Athid = profileURLData(location?.pathname, 'athlete_id');
  // +props?.match?.params?.id;
  const isToken = profileURLData(location?.pathname, 'token');
  // props?.match?.params?.isToken == 1 ? 1 : 0;
  const isCPType = props?.match?.params?.isCPType == 1 ? 1 : 0;
  const fakeInput = useRef(null);
  const [isPublicView, setIsPublicView] = useState(false);
  // profileURLData(location?.pathname, 'public_profile', !!location?.state ? true : false)
  // !!props.publicProfile;
  const [isPublic, setIsPublic] = useState(false);
  const [expand, setExpand] = useState(false);
  const [athletePersonalInfo, setAthletePersonalInfo] = useState(null);
  const [commitmentInfo, setCommitmentInfo] = useState(null);
  const [additionalSportCount, setAdditionalSportCount] = useState(0);
  const [statMatrixData, setStatMatrixData] = useState([]);
  const [profileImages, setProfileImages] = useState(null);
  const [shouldShowUnverifiedShieldModal, setShouldShowUnverifiedShieldModal] =
    useState(false);
  const [shouldShowVerifiedShieldModal, setShouldShowVerifiedShieldModal] =
    useState(false);
  const [isActive, setIsActive] = useState(false);
  const [featuredVideo, setFeaturedVideo] = useState(null);
  const [isShare, setIsShare] = useState(false);
  const [isTab, setIsTab] = useState(0);
  const [confirmModal, setConfirmModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const isPremier = useSelector((athlete) => athlete);
  const store = useSelector((store) => store);
  const memberShip = useDispatch();
  const pubViewID = JSON.parse(localStorage.getItem('pubViewID'));
  const [pubID, setPubID] = useState(null);
  const [renderCount, setRenderCount] = useState(0);
  const [verifiedData, setVerifiedData] = useState([]);
  const [setFeatured, isSetFeatured] = useState(false);
  const [athleteInfo, setAthleteInfo] = useState(null);
  const [isShowMore, setAIsShowMore] = useState(true);
  const [vidID, setVidID] = useState(null);
  const [isVidPop, setIsVidPop] = useState(false);
  const [allCountryList, setAllCountryList] = useState([
    {
      id: 0,
      countrycode: '',
      countryname: '',
      countryflagimage: '',
    },
  ]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [collegeData, setCollegeData] = useState([]);
  const [fields, setFields] = React.useState({
    collegeName: {
      id: 0,
      collegename: '',
    },
  });
  const [errors, setErrors] = React.useState({});
  //This will check is the privacy setting clicked from dropdown of initials.
  const showSetting = localStorage.getItem('showWithSetting');
  const [tellUsField, setTellUsField] = useState({});
  const [initialTellUsData, setInitialTellData] = useState({});
  const [captcha, setCaptcha] = useState('');
  const [isClaimPop, setIsClaimPop] = useState(false);
  const [isAthleteRemoved, setIsAthleteRemoved] = useState(false);
  const [updateCountReq, setUpdateCountReq] = useState(0);

  const getPublicViewData = () => {
    const profileStatus = sessionStorage?.getItem('athlete_own_profile');
    // location?.state
    if (profileStatus == 'true') {
      setIsPublicView(false);
      setIsPublic(false);
    } else {
      setIsPublicView(true);
      setIsPublic(true);
    }
  };
  const checkAthleteRemoveToken = async (Aid = null) => {
    if (Aid) {
      await fetchGraphMethod(
        checkAccountStatus,
        {
          userid: parseInt(Aid),
        },
        true
      ).then((res) => {
        if (res?.status == 200) {
          if (res?.data?.data?.AthleteCheckAccountStatus?.status !== 200) {
            //messagePopup("", "Your account has been removed, Please mail us at team@sportsforceonline.com", "success");
            swal({
              text: 'Your account has been removed, Please mail us at team@sportsforceonline.com',
              icon: 'warning',
              buttons: {
                confirm: { text: 'Go to Homepage' },
              },
            }).then((res) => {
              if (res) {
                history.push('/');
              }
            });
            setIsAthleteRemoved(true);
          } else {
            setIsAthleteRemoved(false);
          }
        }
      });
    }
  };
  //saga call for membership data
  useEffect(async () => {
    //props && props?.checkRemovedAthlete && await checkAthleteRemoveToken();
    goTop();
    if (!!localStorage.getItem('authToken') && isToken == 1) {
      memberShip({
        type: 'MEMBERSHIP_LIST_START',
        payload: {
          query: getAllMembershipsQuery,
          variables: {
            where: {
              userid: !!Athid
                ? Athid
                : !!store?.athlete?.dashboard?.home?.athleteProfileStatus
                    ?.status
                ? +pubViewID || 0
                : getUserInfo()
                ? getUserInfo().id
                : '',
              active: 1,
            },
          },
          isPremierCheck: true,
        },
      });
    }
  }, []);

  useEffect(() => {
    //this check in harshit code because this api is a tokenise api
    if (!!localStorage.getItem('authToken') && isToken == 1) {
      loadColleges();
    }
  }, []);

  useEffect(async () => {
    if (props?.athleteProfileData?.data) {
      const commintmentProps =
        props?.athleteProfileData?.data?.allData?.collegeCommitment?.[0] ?? [];
      const athletePersonalInfoT =
        props.athleteProfileData.data?.allData?.data?.[0] ?? [];
      const additionalSports = props.athleteProfileData.data?.allData
        ?.additionalSportsCount
        ? props.athleteProfileData.data?.allData?.additionalSportsCount[0]
          ? props.athleteProfileData.data?.allData?.additionalSportsCount[0]
              ?.totalCount
          : 0
        : 0;
      const featuredVideoList =
        props?.athleteProfileData?.data?.allData?.featuredPhotosAndVideos;
      let profileImagesT = [];

      // Previous this is the bugs
      // if (athletePersonalInfoT?.profileImages) {

      // }
      if (props?.athleteProfileData?.data?.allData?.profileImages?.length > 0) {
        for (const data of props?.athleteProfileData?.data?.allData
          ?.profileImages) {
          if (data.photosname) {
            if (data.photosname === athletePersonalInfoT?.profileImages) {
              profileImagesT.unshift(data); // = data;
            } else {
              profileImagesT = [...profileImagesT, data];
            }
          }
        }
        // props?.athleteProfileData?.data?.allData?.profileImages?.map(
        //   (item) => {
        //     if (item.photosname === athletePersonalInfoT?.profileImages) {
        //       profileImagesT[0] = item;
        //       return item;
        //     }
        //   }
        // );
        // let data = props?.athleteProfileData?.data?.allData?.profileImages
        //   ?.filter(
        //     (item) => item.photosname !== athletePersonalInfoT?.profileImages
        //   )
        //   .map((item) => {
        //     return profileImagesT.push(item);
        //   });
      } else {
        profileImagesT = props.athleteProfileData.data?.allData?.profileImages;
      }
      props &&
        (await checkAthleteRemoveToken(athletePersonalInfoT?.userId || 0));
      setFeaturedVideo(featuredVideoList);
      setCommitmentInfo(commintmentProps);
      setAdditionalSportCount(additionalSports);
      setAthletePersonalInfo(athletePersonalInfoT);
      setPubID(athletePersonalInfoT?.userId || 0);
      setProfileImages(profileImagesT);
      saveTellUsCommit(athletePersonalInfoT);
      generateCaptcha();
      const isVisitorCountRC = localStorage.getItem(`${Athid}_RC`, 0) ?? 0;
      if (isToken == 0 && isVisitorCountRC == 0) {
        const checkID = getUserInfo()?.athleteLoggedInId ?? 0;
        if (checkID != Athid) {
          localStorage.setItem(`${Athid}_RC`, 1);
          const resCount = await visitorViewCount(
            !!getAuthToken() ? 1 : 0,
            athletePersonalInfoT?.AthleteId ?? 0,
            'VISITOR',
            false
          );
          if (resCount) setUpdateCountReq(updateCountReq + 1);
        }
      }
      //this is for isPublicView State
      getPublicViewData();
    }
  }, [props?.athleteProfileData?.data]);

  useEffect(() => {
    if (showSetting === 'true') {
      setIsActive(true);
    }
  }, [showSetting, store?.athlete?.editUserProfileData?.renderCount?.count]);
  //api call for web from phone number
  useEffect(() => {
    props.countryListStart({
      query: getAllCountriesQuery,
    });
    if (isToken == 1) {
      getAthleteProfile();
    }
  }, []);
  //state set for webForm
  useEffect(() => {
    if (props.athleteData.data) {
      setAthleteInfo(props?.athleteData?.data);
    }
  }, [props?.athleteData]);

  //Effect To Map All Countries List
  useEffect(() => {
    if (props.allCountries && props.allCountries.data) {
      setAllCountryList(props.allCountries.data);
    }
  }, [props.allCountries]);
  // this use effect to set the id in local storage to render the comp as it is on dependecy
  useEffect(() => {
    if (!props?.match?.params?.id) {
      // localStorage.setItem('pubViewID', getUserInfo()?.id)//code is commented as it is creating publicViewId LS undefined
    }
  }, [Athid]);
  const saveTellUsCommit = () => {
    const cloneField = tellUsField;
    if (!!getAuthToken()) {
      cloneField['firstname'] = getCamelCase(getUserInfo()?.FirstName ?? '');
      cloneField['lastname'] = getCamelCase(getUserInfo()?.lastName ?? '');
      cloneField['email'] = getUserInfo()?.Email ?? '';
      cloneField['role'] = getCamelCase(
        getUserInfo()?.role == 'GUARDIAN' ? 'Parent' : getUserInfo()?.role ?? ''
      );
      cloneField['phone'] = getUserInfo()?.phonenumber ?? '';
      cloneField['athleteid'] = getUserInfo()?.id ?? 0;
      cloneField['countryDetails'] = getMyCountryDetails(
        getUserInfo()?.countrycodeid ?? 1
      );
    } else {
      cloneField['countryDetails'] = getMyCountryDetails(1);
    }
    setTellUsField({ ...cloneField });
    setInitialTellData({ ...cloneField });
  };

  const generateCaptcha = (
    chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  ) => {
    let result = '';
    for (let i = 5; i > 0; --i)
      result += chars[Math.floor(Math.random() * chars.length)];
    setCaptcha(result);
  };

  const getAthleteProfile = () => {
    if (props.athleteData.data) {
      props.athleteListStart({
        query: getAllAthletesDataQuery,
        variables: {
          obj: {
            id: getUserInfo() ? getUserInfo().id : 0,
          },
        },
      });
    }
  };

  const getOverviewData = async () => {
    const response = await fetchMethod(
      `/api/Publicprofilefieldpreviews/statsMatrixDetailFromOverView`,
      {
        athleteId: !!Athid
          ? Athid
          : !!store?.athlete?.dashboard?.home?.athleteProfileStatus?.status
          ? +pubViewID || 0
          : !!getUserInfo()
          ? getUserInfo()?.id
          : +pubViewID,
        isAccessToken: isToken,
      },
      'post',
      isToken
    );
    if (response && response.status === 200 && response.data.response.data) {
      setStatMatrixData(response.data.response.data);
    }
  };

  const handleUncommitDialog = async () => {
    setIsDialogOpen(true);
    setErrors({});
    await loadColleges();
  };
  const popUpTellHandle = () => {
    const isLoggedIn = !!getAuthToken();
    if (
      (getUserInfo()?.id == Athid ||
        getUserInfo()?.athleteLoggedInId == Athid) &&
      isLoggedIn &&
      athletePersonalInfo?.Iscommitmentrequestadded == 0
    ) {
      swal({
        text: 'You are viewing your own public profile , please return to your profile to Add Commitment',
        icon: 'warning',
        buttons: {
          confirm: { text: 'Go to my profile' },
          cancel: 'Do it later',
        },
      }).then((res) => {
        if (res) {
          history.push('/viewCommitment');
        }
      });
    } else if (athletePersonalInfo?.Iscommitmentrequestadded == 1) {
      swal({
        text: 'Commitment has been already requested by any other user',
        icon: 'warning',
      });
    } else {
      handleUncommitDialog();
    }
  };

  const handleChange = (field, e) => {
    // let fieldsT = fields;
    // if (field =="phone" && e?.target?.value?.length > 10) return
    // let fieldsT = tellUsField
    // fieldsT[field] = e ? (e.target ? e.target.value : e) : e;

    // format phone number like 000-000-0000
    const fieldsT = tellUsField;
    if (field == 'phone') {
      if (e?.target?.value?.length > 10) return;
      fieldsT[field] = formatPhoneNumber(e.target.value);
    } else {
      fieldsT[field] = e ? (e.target ? e.target.value : e) : e;
    }
    // setFields({
    //   ...fieldsT,
    // });
    setTellUsField({ ...fieldsT });
    setErrors({});
  };

  const loadColleges = async () => {
    const collegeName = 0;
    const _res = await fetchMethod(
      `/allCollegeList/${collegeName}`,
      null,
      'GET',
      false
    );
    if (_res?.status == 200) {
      const collegelist = _res?.data?.data;
      //sort the college list on basis of college name a-z.
      if (collegelist.length > 0) {
        // collegelist.sort(function(a, b){
        //   if(a.collegename < b.collegename) { return -1; }
        //   if(a.collegename > b.collegename) { return 1; }
        //   return 0;
        // });
        // //Select the first college as default. change doc sept 18 no task replace it
        // let fieldsT = fields,
        //     fieldClg = tellUsField; // this is for cloning the commitment filed values
        // fieldsT["collegeName"] = collegelist ? collegelist[0] : "";
        // fieldClg['collegeid'] = collegelist?.[0]?.id ?? 0; // assigning the value of clg
        // fieldClg['collegeName'] = collegelist ? collegelist[0] : ""; // assigning the value of clg
        // setFields({
        //   ...fieldsT,
        // });
        // setTellUsField({...fieldClg})//setting the value in the state
      }
      setCollegeData([...collegelist]);
    }
  };
  const validationCommit = () => {
    let status = true;
    const cloneState = { ...tellUsField },
      cloneError = { ...errors };
    if (!cloneState?.collegeName) {
      cloneError['clg'] = 'Please Select College';
      cloneError['clgStatus'] = true;
      setErrors(cloneError);
      return (status = false);
    }
    if (!cloneState?.role) {
      cloneError['role'] = 'Please Select Role';
      cloneError['roleStatus'] = true;
      setErrors(cloneError);
      return (status = false);
    }
    if (!cloneState?.firstname) {
      cloneError['firstname'] = 'Please Enter First Name';
      cloneError['firstnameStatus'] = true;
      setErrors(cloneError);
      return (status = false);
    }
    if (!!cloneState?.firstname) {
      if (!IsValidName(cloneState?.firstname)) {
        cloneError['firstname'] = 'Please enter a valid First Name';
        cloneError['firstnameStatus'] = true;
        setErrors(cloneError);
        return (status = false);
      }
    }
    if (!cloneState?.lastname) {
      cloneError['lastname'] = 'Please Enter Last Name';
      cloneError['lastnameStatus'] = true;
      setErrors(cloneError);
      return (status = false);
    }
    if (!!cloneState?.lastname) {
      if (!IsValidName(cloneState?.lastname)) {
        cloneError['lastname'] = 'Please enter a valid Last Name';
        cloneError['lastnameStatus'] = true;
        setErrors(cloneError);
        return (status = false);
      }
    }
    if (!cloneState?.email || !IsValidEmail(cloneState?.email ?? '')) {
      cloneError['email'] = 'Please Enter Valid Email';
      cloneError['emailStatus'] = true;
      setErrors(cloneError);
      return (status = false);
    }
    if (!cloneState?.captcha || cloneState?.captcha != captcha) {
      cloneError['captcha'] = 'Please Enter Valid Captcha';
      cloneError['captchaStatus'] = true;
      setErrors(cloneError);
      return (status = false);
    }
    if (!!cloneState?.phone) {
      if (
        !checkPhoneNumberValidation(
          cloneState?.phone,
          cloneState?.countryDetails?.countryShortName ?? 'US'
        )
      ) {
        cloneError['phone'] = 'Please Enter Valid Phone Number';
        cloneError['phoneStatus'] = true;
        setErrors(cloneError);
        return (status = false);
      }
    }
    return status;
  };

  const SubmitDeclare = async (name) => {
    const validationStatus = validationCommit(tellUsField);
    if (validationStatus) {
      const publicId = pubID !== null ? pubID : 0;
      if (publicId > 0) {
        const resMail = await fetchMethod(
          '/api/Commitsforverifications/RequestCommitment',
          {
            athleteid: publicId,
            collegeid: tellUsField?.collegeName?.id,
            role: tellUsField?.role ?? '',
            countryid: tellUsField?.countryDetails?.id ?? 1,
            phone: tellUsField?.phone ?? '',
            firstname: tellUsField?.firstname ?? '',
            lastname: tellUsField?.lastname ?? '',
            email: tellUsField?.email ?? '',
            collegename: tellUsField?.collegeName?.collegename ?? '',
            notes: !!tellUsField?.notes
              ? tellUsField?.notes?.replaceAll('"', '')
              : '',
          },
          'POST',
          true
        );
        if (resMail?.status == 200 && resMail?.data?.response?.status == 200) {
          setIsDialogOpen(false);
          swal({
            text: `Thank You! Your submission for ${name} has been sent to SportsForce for review.`,
            icon: 'success',
          });
          setTellUsField({ ...initialTellUsData });
          setErrors({});
        } else {
          setIsDialogOpen(false);
          swal({
            text: `Commitment status has been in progress by SportsForce team`,
            icon: 'warning',
          });
          setTellUsField({ ...initialTellUsData });
          setErrors({});
        }
      }
    }
  };

  useEffect(() => {
    getOverviewData();
    props.athleteProfileDataStart({
      data: {
        athleteId: !!Athid
          ? Athid
          : !!store?.athlete?.dashboard?.home?.athleteProfileStatus?.status
          ? +pubViewID || 0
          : !!getUserInfo()
          ? getUserInfo()?.id
          : +pubViewID,
        isAccessToken: isToken,
        // !!getAuthToken() ? 1 : 0,
        profileViewerId: !!getUserInfo()?.id ? getUserInfo()?.id : 0,
      },
    });
    //this api is integrated for progress bar and need to be handle with token and without token
    getAuthToken() &&
      isToken == 1 &&
      props.profileCalculationListStart({
        query: getProfileCalculationListQuery,
      });
    //this api is integrated for progress bar and need to be handle with token and without token
    getAuthToken() &&
      isToken == 1 &&
      props.checkListDataStart({
        query: getAllCheckListDataQuery,
        variables: {
          obj: {
            id: getUserInfo().id,
          },
        },
      });
  }, [
    pubViewID,
    store?.athlete?.dashboard?.home?.athleteProfileStatus?.status,
    renderCount,
    Athid,
    updateCountReq,
  ]);

  const EditButton = (e) => {
    e.preventDefault();
    history.push('/basic');
  };

  const goTop = () => {
    fakeInput?.current?.focus();
    fakeInput?.current?.select();
  };
  const handelClaimProfile = () => {
    props.matchotpStart({
      data: {
        otp: !!localStorage.getItem('athleteId')
          ? localStorage.getItem('athleteId').toString()
          : Athid?.toString(),
        useFor: 'login',
        otpOrId: 'id',
        isAthID: !!localStorage.getItem('athleteId') ? 1 : 0,
      },
      nextScreen: '/login',
    });
    localStorage.removeItem('claimProfileKey');
  };

  const openVideoLinkModal = () => {
    const isLoggedIn = !!getAuthToken();
    if (
      featuredVideo?.[0]?.isphotosorvideosLik === 2 &&
      featuredVideo?.[0]?.videolink
    ) {
      // window.open(featuredVideo?.[0]?.videolink, '_blank');
      setVidID(featuredVideo?.[0]?.videolink);
      setTimeout(() => {
        setIsVidPop(true);
      }, 500);
    } else if (featuredVideo?.length > 0) {
      setOpenModal(!openModal);
    } else if (
      featuredVideo?.length == 0 &&
      athletePersonalInfo?.AthleteId != getUserInfo()?.id
    ) {
      isSetFeatured(true);
    } else if (
      featuredVideo?.length == 0 &&
      athletePersonalInfo?.AthleteId == getUserInfo()?.id &&
      isLoggedIn
    ) {
      swal({
        text: 'You are viewing your own public profile, please return to your profile to add video.',
        icon: 'warning',
        buttons: {
          confirm: { text: 'Go to my profile' },
          cancel: 'Do it later',
        },
      }).then((res) => {
        if (res) {
          history.push('/videoPhotos');
        }
      });
    }
    //this check is for vid count increment
    if (featuredVideo?.length > 0) {
      vidCountIncre(featuredVideo?.[0], true);
    }
  };

  const openVideoModal = () => {
    setOpenModal(!openModal);
  };

  //this func is for putting check over publicView route follow icon
  const getCheckStatus = () => {
    if (!isPublicView || isPublic) return true;
    return false;
  };
  //this fun is returning the value when athlete is follow or not
  const getFollowStatus = (value) => {
    if (value?.FollowedStatus) return 'Unfollow';
    return 'Follow';
  };
  const getTipText = () => {
    let text = '';
    if (athletePersonalInfo?.AthleteId == getUserInfo()?.id) {
      if (featuredVideo?.length == 0) {
        // text = "Add your featured video here"//ealier this text was there
        text = '';
      } else {
        text = 'Featured video';
      }
    } else if (athletePersonalInfo?.AthleteId != getUserInfo()?.id) {
      if (featuredVideo?.length == 0) {
        text = 'Request for featured video';
      } else {
        text = 'Featured video';
      }
    }
    return text;
  };
  const getCP = () => {
    if (
      // localStorage.getItem("claimProfileKey") ||
      isCPType == 1
    ) {
      return true;
    } else {
      return false;
    }
  };
  //this code is added as there is error of useEffect $hashit work
  const getCommittedLogo = () => {
    const logo =
      !!commitmentInfo?.collegelogo || commitmentInfo?.collegename
        ? !!commitmentInfo?.collegelogo
          ? `${imageDownloadUrl}/${commitmentInfo?.collegelogo}`
          : TeamLogo
        : '';
    return logo;
  };
  const handleCountryChange = (option) => {
    const fieldsT = { ...tellUsField };
    // setError({})
    fieldsT['countryDetails'] = option;
    setTellUsField({ ...fieldsT, phone: '' });
  };
  const getMyCountryDetails = (id) => {
    let countryT = null;
    allCountryList?.map((country) => {
      if (country.id === id) {
        countryT = {
          value: country.id,
          label: country.countryName + `(+${country.countryCode})`,
          flag: country.countryFlagImage,
          countryCode: country.countryCode,
          countryShortName: country.countryShortName,
        };
      }
    });
    return countryT;
  };
  const onCloseTelUs = () => {
    setIsDialogOpen(false);
    setTellUsField({ ...initialTellUsData });
    setErrors({});
  };
  const getFeaturedVid = () => {
    let text = '';
    if (athletePersonalInfo?.AthleteId == getUserInfo()?.id && !isPublicView) {
      text = 'Add Video';
    } else {
      text = 'Request Video';
    }
    return text;
  };
  const getClaimStatus = () => {
    // this below code is commented as client dont want to take is on alpha 1.0 so return false is done static
    //if enable this functionalit remove return false and uncomment below code
    /////////////////////
    // if ((athletePersonalInfo?.athleteInviteStatus == 0 || athletePersonalInfo?.athleteInviteStatus == 1)
    //     && isPublicView){
    //   return true
    // }else{
    //   return false
    // }
    /////////////////
    return false;
  };
  const updateClaimReq = () => {
    props.athleteProfileDataStart({
      data: {
        athleteId: !!Athid
          ? Athid
          : !!store?.athlete?.dashboard?.home?.athleteProfileStatus?.status
          ? +pubViewID || 0
          : !!getUserInfo()
          ? getUserInfo()?.id
          : +pubViewID,
        isAccessToken: isToken,
        // !!getAuthToken() ? 1 : 0,
        profileViewerId: !!getUserInfo()?.id ? getUserInfo()?.id : 0,
      },
    });
  };
  const getCommittedClgName = (data = '') => {
    return data ? (data.length < 36 ? data : data?.slice(0, 36) + '...') : '';
  };
  return (
    <Root>
      {/*<GetHelmet*/}
      {/*title={getTitleShare()}*/}
      {/*content={getContShare()}*/}
      {/*Ogurl={`${websiteDefaultUrl}publicView/0/${athletePersonalInfo?.userId}/athlete/${athletePersonalInfo?.athleteFirstName}.${athletePersonalInfo?.athleteLastName}`}*/}
      {/*/>*/}
      <Dialog
        open={isShare}
        onClose={(event, reason) => {
          if (reason == 'backdropClick' || reason == 'escapeKeyDown') {
            setIsShare(!isShare);
          }
        }}
        className="matDialogCustom"
      >
        <SharePost
          handleModal={() => setIsShare(!isShare)}
          pageType={'Public'}
          modalData={athletePersonalInfo}
          userID={
            !!Athid
              ? Athid
              : !!store?.athlete?.dashboard?.home?.athleteProfileStatus?.status
              ? +pubViewID || 0
              : !!getUserInfo()
              ? getUserInfo().id
              : +pubViewID
          }
          pubID={pubID}
        />
      </Dialog>

      <Dialog
        open={isDialogOpen}
        onClose={(event, reason) => {
          if (reason == 'backdropClick' || reason == 'escapeKeyDown') {
            onCloseTelUs();
          }
        }}
        className="matDialogCustom matDialogCustomOverlay"
      >
        <div
          className="modal declare-here-modal"
          id="DeclareHereModal"
          style={{ display: 'block' }}
        >
          <div
            className="modal-dialog modal-lg modal-dialog-centered"
            role="document"
          >
            <form className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Commitment -{' '}
                  {getCamelCase(athletePersonalInfo?.athleteFirstName ?? '')}{' '}
                  {getCamelCase(athletePersonalInfo?.athleteLastName ?? '')}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => onCloseTelUs()}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body bottom-border">
                <div
                  className="fieldBox text-center"
                  style={{ lineHeight: '1.5', marginBottom: '20px' }}
                >
                  <p style={{ marginBottom: '5px' }}>
                    Hey, Please complete the form so we can give you credit for
                    reporting this information.
                  </p>
                  {athletePersonalInfo
                    ? (athletePersonalInfo.athleteFirstName
                        ? getCamelCase(athletePersonalInfo.athleteFirstName)
                        : '') +
                      ' ' +
                      (athletePersonalInfo.athleteLastName
                        ? getCamelCase(athletePersonalInfo.athleteLastName)
                        : '')
                    : ''}{' '}
                  has been committed to:
                </div>
                <div className="fieldBox">
                  <label className={'mb-0'}>
                    Select College <sup>*</sup>
                  </label>
                  {/*<div className="flexRow">*/}
                  {/*  <div className="col">*/}
                  <MuiAutoComplete
                    id="combo-box-demo"
                    freeSolo={true}
                    options={collegeData}
                    getOptionLabel={(option) =>
                      option.collegename && option?.city && option?.state
                        ? `${
                            !!option.collegename
                              ? getCamelCase(option.collegename)
                              : ''
                          } - [${
                            !!option?.city ? getCamelCase(option?.city) : ''
                          }, ${
                            !!option?.state ? getCamelCase(option?.state) : ''
                          }]`
                        : getCamelCase(option?.collegename)
                    }
                    value={fields.collegeName || null}
                    onChangeObj={(e, data) => {
                      handleChange('collegeName', {
                        target: { value: data },
                      });
                    }}
                    inputPlaceholder="College Name"
                  />
                  <div className="error">
                    {errors['clgStatus'] ? 'Please Select College' : ''}
                  </div>
                  {/*  </div>*/}
                  {/*</div>*/}
                </div>
                <div className="fieldBox flexBox">
                  <div className="half">
                    <label>
                      Role <sup>*</sup>
                    </label>
                    <select
                      value={tellUsField?.role ?? ''}
                      disabled={!!getAuthToken() ? true : false}
                      onChange={(e) => handleChange('role', e?.target?.value)}
                    >
                      <option value="">Please Select</option>
                      <option value="ADVISORS">Advisor</option>
                      <option value="Athletes">Athlete</option>
                      <option value="Parent">Parent</option>
                      <option value="College Coach">College Coach</option>
                      <option value="Coach">Coach</option>
                      <option value="Scout">Scout</option>
                      <option value="Fan">Fan</option>
                      <option value="Other">Other</option>
                    </select>
                    {errors?.roleStatus && (
                      <span className={'error'}>{errors?.role}</span>
                    )}
                  </div>
                  <div className="half">
                    <label>Mobile Phone</label>
                    <PhoneNumber
                      dropdownName="countryCode"
                      dropdownOnChange={handleCountryChange}
                      dropdownValue={tellUsField?.countryDetails ?? 1}
                      dropDownOptions={allCountryList?.map((item) => ({
                        value: item.id,
                        label: item.countryName + `(+${item.countryCode})`,
                        flag: item.countryFlagImage,
                        countryCode: item.countryCode,
                        countryShortName: item.countryShortName,
                      }))}
                      formatOptionLabel={(option, { context, selectValue }) => {
                        return context === 'menu' ? (
                          <>
                            <img
                              src={option.flag}
                              alt=""
                              style={{ width: '40px', marginRight: '15px' }}
                            />
                            <span>{option.label}</span>
                          </>
                        ) : (
                          <>
                            <img
                              src={option.flag}
                              alt=""
                              style={{ width: '40px', marginRight: '15px' }}
                            />
                            <span>+{option.countryCode}</span>
                          </>
                        );
                      }}
                      inputPlaceholder="Phone Number"
                      inputType="phonenumber"
                      inputValue={tellUsField?.phone || ''}
                      inputOnChange={(e) => {
                        handleChange('phone', {
                          target: {
                            value: e.target.value.replace(/[^0-9]/gi, ''),
                          },
                        });
                      }}
                    />
                    {errors?.phoneStatus && (
                      <span className={'error'}>{errors?.phone}</span>
                    )}
                  </div>
                </div>
                <div className="fieldBox flexBox">
                  <div className="half">
                    <label>
                      First Name <sup>*</sup>
                    </label>
                    <input
                      type="text"
                      value={tellUsField?.firstname ?? ''}
                      disabled={!!getAuthToken() ? true : false}
                      placeholder="Enter first name"
                      onChange={(e) =>
                        handleChange('firstname', e?.target?.value)
                      }
                    />
                    {errors?.firstnameStatus && (
                      <span className={'error'}>{errors?.firstname}</span>
                    )}
                  </div>
                  <div className="half">
                    <label>
                      Last Name <sup>*</sup>
                    </label>
                    <input
                      type="text"
                      value={tellUsField?.lastname ?? ''}
                      placeholder="Enter last name"
                      disabled={!!getAuthToken() ? true : false}
                      onChange={(e) =>
                        handleChange('lastname', e?.target?.value)
                      }
                    />
                    {errors?.lastnameStatus && (
                      <span className={'error'}>{errors?.lastname}</span>
                    )}
                  </div>
                </div>
                <div className="fieldBox full">
                  <label>
                    Email <sup>*</sup>
                  </label>
                  <input
                    type="text"
                    value={tellUsField?.email ?? ''}
                    placeholder="Enter Email"
                    disabled={!!getAuthToken() ? true : false}
                    onChange={(e) => handleChange('email', e?.target?.value)}
                  />
                  {errors?.emailStatus && (
                    <span className={'error'}>{errors?.email}</span>
                  )}
                </div>
                <div className="fieldBox full">
                  <label>
                    Add Commitment / Signing Announcement (weblink, source,
                    etc.)
                  </label>
                  <textarea
                    onChange={(e) => handleChange('notes', e)}
                    value={tellUsField?.notes ?? ''}
                    placeholder="Enter your commitment / signing announcement here..."
                  ></textarea>
                </div>
                <div className="fieldBox full">
                  <label>
                    Captcha <sup>*</sup>
                  </label>
                  <div className="captcha-flex-box">
                    <div className="item">
                      <input
                        type="text"
                        placeholder="Enter Captcha"
                        onChange={(e) =>
                          handleChange('captcha', e?.target?.value)
                        }
                      />
                      {errors?.captchaStatus && (
                        <span className={'error'}>{errors?.captcha}</span>
                      )}
                    </div>
                    <div className="captcha-code">
                      <span className="code">{captcha}</span>
                      <span className="icon" onClick={() => generateCaptcha()}>
                        <img src={refresh} alt="" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-none">
                <button
                  type="button"
                  className="btn blue"
                  data-dismiss="modal"
                  onClick={() =>
                    SubmitDeclare(
                      athletePersonalInfo.athleteFirstName +
                        ' ' +
                        athletePersonalInfo.athleteLastName
                    )
                  }
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </Dialog>

      <Dialog
        open={shouldShowUnverifiedShieldModal}
        onClose={(event, reason) => {
          if (reason == 'backdropClick' || reason == 'escapeKeyDown') {
            setShouldShowUnverifiedShieldModal(
              !shouldShowUnverifiedShieldModal
            );
          }
        }}
        className="matDialogCustom"
      >
        <VerificationModal
          onClose={() =>
            setShouldShowUnverifiedShieldModal(!shouldShowUnverifiedShieldModal)
          }
          verifiedData={verifiedData}
          profileImages={profileImages}
        />
      </Dialog>
      <Dialog
        open={shouldShowVerifiedShieldModal}
        onClose={(event, reason) => {
          if (reason == 'backdropClick' || reason == 'escapeKeyDown') {
            setShouldShowVerifiedShieldModal(false);
          }
        }}
        className="matDialogCustom"
      >
        <VerifiedShieldModal
          setShouldShowVerifiedShieldModal={setShouldShowVerifiedShieldModal}
        />
      </Dialog>
      <Dialog
        open={openModal}
        className={'video-modal-profile'}
        aria-labelledby="customized-dialog-title"
        onClose={(event, reason) => {
          if (reason == 'backdropClick' || reason == 'escapeKeyDown') {
            openVideoModal();
          }
        }}
      >
        <DialogContent
          classes={{
            root: classes.root,
          }}
          style={{ padding: '0px' }}
        >
          {featuredVideo?.[0]?.isphotosorvideosLik === 2 ? (
            <iframe
              width="700"
              height="400"
              src={featuredVideo?.[0]?.videolink}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : (
            <video
              controls
              autoPlay={true}
              controlsList={isToken == 1 ? '' : 'nodownload'}
              style={{ backgroundColor: 'black' }}
            >
              <source
                src={
                  featuredVideo?.length > 0
                    ? `${imageDownloadUrl}/${
                        typeConvert(
                          featuredVideo?.[0]?.videoname,
                          'Athlete_Info'
                        ) + '#t=0.2'
                      }`
                    : ''
                }
                alt="video/youtube"
              />
            </video>
          )}
        </DialogContent>
      </Dialog>
      <Dialog
        open={setFeatured}
        onClose={(event, reason) => {
          if (reason == 'backdropClick' || reason == 'escapeKeyDown') {
            isSetFeatured(false);
          }
        }}
        className="matDialogCustom matDialogCustomOverlay"
      >
        <WebForm
          isSetFeatures={isSetFeatured}
          countries={allCountryList}
          isToken={isToken}
          athleteInfo={athleteInfo}
          athletePersonalInfoRest={athletePersonalInfo}
        />
      </Dialog>
      <Dialog
        open={isClaimPop}
        onClose={(event, reason) => {
          if (reason == 'backdropClick' || reason == 'escapeKeyDown') {
            setIsClaimPop(!isClaimPop);
          }
        }}
        className="matDialogCustom"
      >
        <ClaimProfilePop
          closeModal={() => setIsClaimPop(!isClaimPop)}
          allCountryList={allCountryList}
          isToken={isToken}
          athleteInfo={athletePersonalInfo}
          updateClaimReq={() => updateClaimReq()}
        />
      </Dialog>
      <VideoPop
        vidID={vidID}
        isTestSingle={isVidPop}
        setIsTestSingle={() => setIsVidPop()}
        isLink={true}
        isToken={isToken}
      />
      {isToken ? <DashboardHeader /> : <ClaimProfileHeader />}
      <div className="athleteProfileFinalDarkSection pb-0">
        <input className="fakeInput" type="text" ref={fakeInput} />
        {!isAthleteRemoved ? (
          <div
            className="topSection"
            style={{
              backgroundImage: `url(${imageDownloadUrl}/Groundbg.svg)`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            }}
          >
            <div className="coachProfileFlexBox">
              <div className="carousel">
                {isPublicView ? (
                  isPremier?.athlete?.editUserProfileData?.getprofileTimelineStatusTabs?.data?.profileTimelineAbout?.map(
                    (el, idx) => {
                      if (el?.publicprofilefieldid == 21 && el?.active == 1) {
                        return (
                          <ProfilePicCarousel
                            profileImages={profileImages}
                            athletePersonalInfo={athletePersonalInfo}
                          />
                        );
                      } else if (
                        el?.publicprofilefieldid == 21 &&
                        el?.active == 0
                      ) {
                        return (
                          <span
                            className="icon"
                            style={{
                              position: 'absolute',
                              top: '55px',
                              paddingLeft: '35px',
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="100"
                              height="100"
                              viewBox="0 0 13.286 15.5"
                            >
                              <defs>
                                <style></style>
                              </defs>
                              <g transform="translate(-4.5 -2.25)">
                                <path
                                  className="a"
                                  d="M15.571,8.893a2.214,2.214,0,0,1,2.214,2.214v4.429a2.214,2.214,0,0,1-2.214,2.214H6.714A2.214,2.214,0,0,1,4.5,15.536V11.107A2.214,2.214,0,0,1,6.714,8.893V6.679a4.429,4.429,0,1,1,8.857,0ZM11.143,3.726A2.952,2.952,0,0,1,14.1,6.679V8.893H8.19V6.679a2.952,2.952,0,0,1,2.952-2.952Zm4.429,6.643H6.714a.738.738,0,0,0-.738.738v4.429a.738.738,0,0,0,.738.738h8.857a.738.738,0,0,0,.738-.738V11.107A.738.738,0,0,0,15.571,10.369Z"
                                />
                              </g>
                            </svg>
                          </span>
                        );
                      }
                    }
                  ) || ''
                ) : (
                  <ProfilePicCarousel
                    profileImages={profileImages}
                    athletePersonalInfo={athletePersonalInfo}
                  />
                )}
                {/*<div className="profileCarousel owl-carousel owl-theme"></div>*/}
              </div>
              <div className="coachInfo">
                <h2 className="pName">
                  <span>
                    {athletePersonalInfo
                      ? (getCamelCase(athletePersonalInfo.athleteFirstName)
                          ? getCamelCase(athletePersonalInfo.athleteFirstName)
                          : '') +
                        ' ' +
                        (getCamelCase(athletePersonalInfo.athleteLastName)
                          ? getCamelCase(athletePersonalInfo.athleteLastName)
                          : '')
                      : ''}
                  </span>
                  <span className="icon">
                    {athletePersonalInfo?.verifiedUser ? (
                      <svg
                        style={{ cursor: 'pointer' }}
                        xmlns="http://www.w3.org/2000/svg"
                        width="26.418"
                        height="26.403"
                        viewBox="0 0 26.418 26.403"
                        className="verified"
                        onClick={(e) =>
                          setShouldShowVerifiedShieldModal(
                            !shouldShowVerifiedShieldModal
                          )
                        }
                      >
                        <defs>
                          <style></style>
                        </defs>
                        <path
                          className="a"
                          d="M-4229.021-6663.778a1.151,1.151,0,0,1-.986-.543,1.174,1.174,0,0,0-.993-.543,1.174,1.174,0,0,0-.993.543,1.151,1.151,0,0,1-.986.543,1.169,1.169,0,0,1-1.152-.9v-.005a1.179,1.179,0,0,0-1.149-.9,1.16,1.16,0,0,0-.728.256,1.169,1.169,0,0,1-.729.259,1.2,1.2,0,0,1-.883-.392,1.158,1.158,0,0,1-.3-.9l0-.013a1.161,1.161,0,0,0-.3-.9,1.184,1.184,0,0,0-.87-.387,1.181,1.181,0,0,0-.395.068h-.005a1.189,1.189,0,0,1-.4.07,1.175,1.175,0,0,1-.984-.544,1.155,1.155,0,0,1-.084-1.116l.01-.021a1.174,1.174,0,0,0-.088-1.121,1.175,1.175,0,0,0-.989-.538h-.033a1.163,1.163,0,0,1-1.08-.708,1.164,1.164,0,0,1,.219-1.274l.019-.019a1.171,1.171,0,0,0,.28-1.09,1.176,1.176,0,0,0-.769-.831l-.02,0a1.164,1.164,0,0,1-.8-1.02,1.164,1.164,0,0,1,.621-1.138l.02-.01a1.174,1.174,0,0,0,.621-.943,1.172,1.172,0,0,0-.456-1.031l-.02-.017a1.161,1.161,0,0,1-.425-1.223,1.164,1.164,0,0,1,.957-.875l.017,0a1.174,1.174,0,0,0,.894-.688,1.172,1.172,0,0,0-.1-1.125l-.013-.021a1.159,1.159,0,0,1-.058-1.2,1.173,1.173,0,0,1,1.03-.625,1.229,1.229,0,0,1,.215.019h.008a1.234,1.234,0,0,0,.21.019,1.166,1.166,0,0,0,.928-.459,1.169,1.169,0,0,0,.207-1.017l0-.017a1.148,1.148,0,0,1,.2-1.012,1.2,1.2,0,0,1,.938-.467,1.169,1.169,0,0,1,.572.151,1.16,1.16,0,0,0,.571.15,1.186,1.186,0,0,0,1.177-1.092v-.01a1.176,1.176,0,0,1,1.184-1.092,1.158,1.158,0,0,1,.866.39,1.159,1.159,0,0,0,.871.39,1.18,1.18,0,0,0,1.086-.715,1.162,1.162,0,0,1,1.084-.717,1.162,1.162,0,0,1,1.084.715,1.18,1.18,0,0,0,1.086.717,1.159,1.159,0,0,0,.871-.39,1.158,1.158,0,0,1,.866-.39,1.176,1.176,0,0,1,1.184,1.092v.01a1.186,1.186,0,0,0,1.177,1.092,1.16,1.16,0,0,0,.569-.148,1.164,1.164,0,0,1,.574-.153,1.2,1.2,0,0,1,.938.467,1.148,1.148,0,0,1,.2,1.012l-.005.017a1.169,1.169,0,0,0,.207,1.017,1.166,1.166,0,0,0,.928.459,1.234,1.234,0,0,0,.21-.019h.008a1.229,1.229,0,0,1,.215-.019,1.172,1.172,0,0,1,1.029.625,1.158,1.158,0,0,1-.057,1.2l-.013.021a1.172,1.172,0,0,0-.1,1.125,1.174,1.174,0,0,0,.894.688l.017,0a1.164,1.164,0,0,1,.958.875,1.161,1.161,0,0,1-.425,1.222l-.021.017a1.173,1.173,0,0,0-.456,1.032,1.174,1.174,0,0,0,.621.943l.021.01a1.164,1.164,0,0,1,.621,1.138,1.164,1.164,0,0,1-.8,1.02l-.02,0a1.179,1.179,0,0,0-.769.831,1.171,1.171,0,0,0,.283,1.09l.016.019a1.164,1.164,0,0,1,.218,1.273,1.163,1.163,0,0,1-1.08.708h-.033a1.175,1.175,0,0,0-.989.538,1.174,1.174,0,0,0-.088,1.121l.01.021a1.154,1.154,0,0,1-.083,1.116,1.175,1.175,0,0,1-.984.544,1.185,1.185,0,0,1-.4-.07h-.005a1.181,1.181,0,0,0-.395-.068,1.184,1.184,0,0,0-.87.387,1.161,1.161,0,0,0-.3.9v.013a1.157,1.157,0,0,1-.3.9,1.2,1.2,0,0,1-.883.392,1.159,1.159,0,0,1-.727-.259,1.164,1.164,0,0,0-.729-.256,1.181,1.181,0,0,0-1.15.9v0A1.168,1.168,0,0,1-4229.021-6663.778Zm-7.2-15.261a.709.709,0,0,0-.522.232l-1.041,1.122a.835.835,0,0,0,0,1.12l4.787,5.15a.712.712,0,0,0,.522.231.71.71,0,0,0,.52-.231l8.471-9.111a.84.84,0,0,0,0-1.122l-1.041-1.12a.711.711,0,0,0-.522-.232.705.705,0,0,0-.521.232l-6.908,7.43-3.226-3.469A.706.706,0,0,0-4236.221-6679.039Z"
                          transform="translate(4244.209 6690.181)"
                        />
                      </svg>
                    ) : (
                      <span
                        style={{ cursor: 'pointer' }}
                        onClick={(e) =>
                          setShouldShowUnverifiedShieldModal(
                            !shouldShowUnverifiedShieldModal
                          )
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25.828"
                          height="25.997"
                          viewBox="0 0 25.828 25.997"
                          className="unverified"
                          style={{ display: 'block' }}
                        >
                          <defs>
                            <style></style>
                          </defs>
                          <g transform="translate(-306 -179)">
                            <path
                              className="a"
                              d="M-5645.777-718.874a1.147,1.147,0,0,1,2.111,0l0,.009a1.147,1.147,0,0,0,1.91.317h0a1.146,1.146,0,0,1,2,.68l0,.034a1.146,1.146,0,0,0,1.7.916l.008,0a1.146,1.146,0,0,1,1.669,1.288l-.016.062a1.146,1.146,0,0,0,1.31,1.416l.033-.006a1.146,1.146,0,0,1,1.159,1.758l-.047.071a1.147,1.147,0,0,0,.776,1.761l.063.01a1.146,1.146,0,0,1,.521,2.038l-.071.055a1.146,1.146,0,0,0,.16,1.916l.074.04a1.146,1.146,0,0,1-.175,2.1l-.072.024a1.146,1.146,0,0,0-.474,1.864l.061.066a1.146,1.146,0,0,1-.852,1.924h-.049a1.147,1.147,0,0,0-1.058,1.61l.031.07a1.146,1.146,0,0,1-1.433,1.544l-.019-.007a1.147,1.147,0,0,0-1.527,1.182l0,.049a1.147,1.147,0,0,1-1.859,1l0,0a1.146,1.146,0,0,0-1.831.625l0,.02a1.146,1.146,0,0,1-2.082.344v0a1.146,1.146,0,0,0-1.937,0v0a1.146,1.146,0,0,1-2.082-.344l0-.02a1.146,1.146,0,0,0-1.831-.625l0,0a1.146,1.146,0,0,1-1.859-1l0-.049a1.146,1.146,0,0,0-1.527-1.182l-.019.007a1.146,1.146,0,0,1-1.434-1.544l.031-.07a1.146,1.146,0,0,0-1.057-1.61h-.049a1.146,1.146,0,0,1-.852-1.924l.061-.066a1.146,1.146,0,0,0-.474-1.864l-.072-.024a1.146,1.146,0,0,1-.175-2.1l.075-.04a1.146,1.146,0,0,0,.16-1.916l-.071-.055a1.146,1.146,0,0,1,.521-2.038l.062-.01a1.146,1.146,0,0,0,.777-1.761l-.047-.071a1.146,1.146,0,0,1,1.158-1.758l.034.006a1.146,1.146,0,0,0,1.31-1.416l-.016-.062a1.146,1.146,0,0,1,1.669-1.288l.008,0a1.146,1.146,0,0,0,1.7-.916l0-.034a1.146,1.146,0,0,1,2-.68h0a1.146,1.146,0,0,0,1.91-.317Z"
                              transform="translate(5963.635 898.573)"
                            />
                            <path
                              className="b"
                              d="M4.452-10.374,4.13-3.7H1.792L1.47-10.374ZM2.968.112A1.676,1.676,0,0,1,1.8-.287,1.309,1.309,0,0,1,1.358-1.3,1.33,1.33,0,0,1,1.8-2.324,1.658,1.658,0,0,1,2.968-2.73a1.638,1.638,0,0,1,1.155.406A1.33,1.33,0,0,1,4.564-1.3,1.315,1.315,0,0,1,4.123-.294,1.638,1.638,0,0,1,2.968.112Z"
                              transform="translate(315.642 197.374)"
                            />
                          </g>
                        </svg>
                      </span>
                    )}
                  </span>
                </h2>
                <span className="designation" style={{ background: 'none' }}>
                  {!!athletePersonalInfo?.sportName
                    ? getCamelCase(athletePersonalInfo?.sportName ?? '') //this changes done as per regretion testing on 29/9/2022
                    : ''}{' '}
                  {additionalSportCount ? ` +${additionalSportCount}` : ''}
                </span>
                <p className="info">
                  {athletePersonalInfo?.highSchoolName
                    ? getCamelCase(athletePersonalInfo.highSchoolName)
                    : ''}
                  {/* {athletePersonalInfo?.city
                  ? athletePersonalInfo.city + ", "
                  : ""}
                {athletePersonalInfo?.state ? athletePersonalInfo.state : ""} */}
                </p>
                <p className="info">
                  {athletePersonalInfo?.schoolNameFromTeam
                    ? athletePersonalInfo?.schoolNameFromTeam
                    : ''}
                </p>
                <p className="info">{athletePersonalInfo?.teamname || ''}</p>
                {/* <p className="email">
                  {athletePersonalInfo?.athletePhoneNumber} - {athleteData?.email}
                </p> */}
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: isMobile ? 'center' : 'flex-start',
                    gap: '10px',
                  }}
                >
                  {!!athletePersonalInfo?.twitterAccountName && (
                    <Avatar
                      sx={{
                        backgroundColor: 'transparent',
                      }}
                    >
                      <a
                        target={'_blank'}
                        href={`https://twitter.com/${athletePersonalInfo?.twitterAccountName}`}
                      >
                        <img src={X} alt="X Logo" width="100%" height="100%" />
                      </a>
                    </Avatar>
                  )}
                  {!!athletePersonalInfo?.instagramAccountName && (
                    <Avatar
                      sx={{
                        backgroundColor: 'transparent',
                      }}
                    >
                      <a
                        style={{ color: 'white' }}
                        target={'_blank'}
                        href={`https://www.instagram.com/${athletePersonalInfo?.instagramAccountName}`}
                      >
                        <img
                          src={InstagramIcon}
                          alt="Instagram Logo"
                          width="100%"
                          height="100%"
                        />
                      </a>
                    </Avatar>
                  )}
                  {props?.athleteProfileData?.data?.allData?.athleteStatLinks?.map(
                    (athleteStatLink, index) => (
                      <Tooltip
                        title={`Check out my ${addSpaceToPascalCase(
                          athleteStatLink.platform
                        )} profile`}
                      >
                        <a
                          href={athleteStatLink.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Avatar
                            key={index}
                            sx={{
                              backgroundColor: 'transparent',
                            }}
                          >
                            <img
                              src={
                                imageDownloadUrl +
                                '/' +
                                PlatformImg[athleteStatLink.platform]
                              }
                              alt="Platform"
                              style={{
                                objectFit: 'cover',
                                width: '100%',
                                height: '100%',
                              }}
                            />
                          </Avatar>
                        </a>
                      </Tooltip>
                    )
                  )}
                </div>
                <ul>
                  <li className="likes">
                    <span className="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21.089"
                        height="15.981"
                        viewBox="0 0 21.089 15.981"
                      >
                        <defs>
                          <style></style>
                        </defs>
                        <g transform="translate(-364.759 -164)">
                          <g transform="translate(364.759 101.997)">
                            <g transform="translate(8.98 68.387)">
                              <g transform="translate(0 0)">
                                <circle
                                  className="a"
                                  cx="1.606"
                                  cy="1.606"
                                  r="1.606"
                                />
                              </g>
                            </g>
                            <g transform="translate(5.89 65.298)">
                              <g transform="translate(0 0)">
                                <path
                                  className="a"
                                  d="M147.709,142a4.7,4.7,0,1,0,4.7,4.7A4.7,4.7,0,0,0,147.709,142Zm0,7.743a3.048,3.048,0,1,1,3.048-3.048A3.051,3.051,0,0,1,147.709,149.745Z"
                                  transform="translate(-143.014 -142.002)"
                                />
                              </g>
                            </g>
                            <g transform="translate(0 62.003)">
                              <g transform="translate(0 0)">
                                <path
                                  className="a"
                                  d="M20.555,68.2a15.923,15.923,0,0,0-3.68-3.9A10.48,10.48,0,0,0,10.563,62a10.534,10.534,0,0,0-6.318,2.288,16.038,16.038,0,0,0-3.7,3.893,3.29,3.29,0,0,0,0,3.619,16.037,16.037,0,0,0,3.7,3.893,10.534,10.534,0,0,0,6.318,2.288,11.425,11.425,0,0,0,7.618-3.392.824.824,0,1,0-1.127-1.2,9.824,9.824,0,0,1-6.491,2.946c-4,0-7.315-3.419-8.644-5.439a1.644,1.644,0,0,1,0-1.808c1.329-2.02,4.645-5.439,8.644-5.439s7.3,3.422,8.612,5.444a1.648,1.648,0,0,1,0,1.8.824.824,0,0,0,1.381.9A3.3,3.3,0,0,0,20.555,68.2Z"
                                  transform="translate(0 -62.003)"
                                />
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                    </span>
                    {/* This will format the number with commas like 1,000  */}
                    <span>
                      {athletePersonalInfo?.profileViewCount
                        ? athletePersonalInfo?.profileViewCount.toLocaleString(
                            'en-US',
                            { maximumFractionDigits: 2 }
                          )
                        : 0}
                    </span>
                  </li>
                  {/* <li className="follower">
                  <span>{followers} </span>
                  <span className="label">followers</span>
                </li>
                <li className="following">
                  <span>{following} </span>
                  <span className="label">following</span>
                </li> */}
                </ul>
              </div>
              <div className="video-with-infobox">
                <div className="video-profilebox">
                  <div
                    className="video-thum"
                    style={
                      featuredVideo?.length == 0
                        ? { border: 'none', height: 'auto' }
                        : {}
                    }
                  >
                    {featuredVideo?.[0]?.isphotosorvideosLik === 1 && (
                      <>
                        <video>
                          <source
                            src={
                              featuredVideo?.length > 0
                                ? `${imageDownloadUrl}/${
                                    typeConvert(
                                      featuredVideo?.[0]?.videoname,
                                      'Athlete_Info'
                                    ) + '#t=0.2'
                                  }`
                                : null
                            }
                            alt="video"
                          />
                        </video>
                        <div className="video-play-button">
                          <div className="video-play-inner">
                            <Tooltip placement="top" title={getTipText()} arrow>
                              <button
                                className="featuredVideo"
                                onClick={() => {
                                  openVideoLinkModal();
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="10.802"
                                  height="16.203"
                                  viewBox="0 0 10.802 16.203"
                                >
                                  <path
                                    className="a"
                                    d="M8.1,0l8.1,10.8H0Z"
                                    transform="translate(10.802) rotate(90)"
                                  ></path>
                                </svg>
                              </button>
                            </Tooltip>
                          </div>
                        </div>
                      </>
                    )}
                    {featuredVideo?.[0]?.isphotosorvideosLik === 2 &&
                      featuredVideo?.[0]?.videolink && (
                        <>
                          <a href={void 0} target="_blank">
                            <video
                              poster={getThumbnail(
                                featuredVideo?.[0]?.videolink,
                                featuredVideo?.[0],
                                isToken == 1 ? 'Profile' : 'ProfileView'
                              )}
                            >
                              <source
                                src={
                                  featuredVideo?.length > 0
                                    ? `${imageDownloadUrl}/${featuredVideo?.[0]?.videolink}`
                                    : null
                                }
                                alt="video"
                              />
                            </video>
                            {/*<iframe*/}
                            {/*    width="241"*/}
                            {/*    height="152"*/}
                            {/*    src={!!featuredVideo?.[0]?.videolink ? featuredVideo?.[0]?.videolink : null}*/}
                            {/*    frameBorder="0"*/}
                            {/*    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"*/}
                            {/*    allowFullScreen*/}
                            {/*></iframe>*/}
                          </a>
                          <div className="video-play-button">
                            <div className="video-play-inner">
                              <Tooltip
                                placement="top"
                                title={getTipText()}
                                arrow
                              >
                                <button
                                  className="featuredVideo"
                                  onClick={() => {
                                    openVideoLinkModal();
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="10.802"
                                    height="16.203"
                                    viewBox="0 0 10.802 16.203"
                                  >
                                    <path
                                      className="a"
                                      d="M8.1,0l8.1,10.8H0Z"
                                      transform="translate(10.802) rotate(90)"
                                    ></path>
                                  </svg>
                                </button>
                              </Tooltip>
                            </div>
                          </div>
                        </>
                      )}
                    {featuredVideo?.length == 0 && (
                      <>
                        <div style={{ display: 'none' }}>
                          <video>
                            <source
                              src={
                                featuredVideo?.length > 0
                                  ? `${imageDownloadUrl}/${
                                      typeConvert(
                                        featuredVideo?.[0]?.videoname,
                                        'Athlete_Info'
                                      ) + '#t=0.2'
                                    }`
                                  : null
                              }
                              alt="video"
                            />
                          </video>
                        </div>
                        <Tooltip placement="top" title={getTipText()} arrow>
                          <button
                            className="btn add-video-btn"
                            onClick={() => {
                              isPublicView
                                ? openVideoLinkModal()
                                : history?.push('/videoPhotos');
                            }}
                          >
                            <span className="icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="23.982"
                                height="15.317"
                                viewBox="0 0 23.982 15.317"
                              >
                                <g
                                  id="Group_57553"
                                  data-name="Group 57553"
                                  transform="translate(-846 -1139.805)"
                                >
                                  <path
                                    id="bx-video"
                                    d="M22.186,9.688a2.3,2.3,0,0,0-2.4-2.188H5.4A2.3,2.3,0,0,0,3,9.688V20.629a2.3,2.3,0,0,0,2.4,2.188H19.788a2.3,2.3,0,0,0,2.4-2.188V16.982l4.8,3.647V9.688l-4.8,3.647Zm-1.6,11.67H4.6V8.959H20.587l0,6.2h0l0,6.2Z"
                                    transform="translate(843 1132.305)"
                                    fill="#fff"
                                  />
                                  <path
                                    id="plus-round"
                                    d="M11.978,7.886H9.24V5.148a.678.678,0,0,0-1.354,0V7.886H5.148a.678.678,0,0,0,0,1.354H7.886v2.738a.678.678,0,0,0,1.354,0V9.24h2.738a.678.678,0,0,0,0-1.354Z"
                                    transform="translate(846.63 1138.901)"
                                    fill="#fff"
                                  />
                                </g>
                              </svg>
                            </span>
                            {getFeaturedVid()}
                          </button>
                        </Tooltip>
                      </>
                    )}
                  </div>
                </div>
                <div
                  className={isShowMore ? 'infoBoxFlex' : 'infoBoxFlex hide'}
                >
                  <div className="item">
                    <div className="item-detail">
                      <span className="label">Grad Year</span>
                      <span style={{ color: '#c0321f' }}>
                        {athletePersonalInfo?.yearValue}
                      </span>
                    </div>
                  </div>
                  <div className="item">
                    <div className="item-detail">
                      <span className="label">Position</span>
                      <span style={{ color: '#c0321f' }}>
                        {athletePersonalInfo?.shortPrimaryPostision
                          ? athletePersonalInfo?.shortPrimaryPostision
                          : ''}{' '}
                        {athletePersonalInfo?.shortPrimaryPostision &&
                        athletePersonalInfo?.shortFormSecondaryPosition
                          ? '/ '
                          : ''}
                        {athletePersonalInfo?.shortFormSecondaryPosition
                          ? athletePersonalInfo?.shortFormSecondaryPosition
                          : ''}
                      </span>
                    </div>
                  </div>
                  <div className="item">
                    <div className="item-detail">
                      <span className="label">Height / Weight</span>
                      {isPublicView ? (
                        isPremier?.athlete?.editUserProfileData?.getprofileTimelineStatusTabs?.data?.profileTimelineAbout?.map(
                          (itm, idx) => {
                            if (
                              itm?.publicprofilefieldid == 25 &&
                              itm.active == 1
                            )
                              return (
                                <span style={{ color: '#c0321f' }}>
                                  {athletePersonalInfo?.heightValue
                                    ? athletePersonalInfo?.heightValue + "'"
                                    : ''}
                                  &nbsp;
                                  {athletePersonalInfo?.heightInInches ||
                                  athletePersonalInfo?.heightInInches === 0
                                    ? `${athletePersonalInfo?.heightInInches}" `
                                    : ''}
                                  {/*{athletePersonalInfo?.heightValue && (athletePersonalInfo?.heightInInches ||*/}
                                  {/*  athletePersonalInfo?.heightInInches === 0) && athletePersonalInfo?.weight ? "/" : ""}*/}
                                  {!!athletePersonalInfo?.weight
                                    ? `/ ${athletePersonalInfo?.weight}`
                                    : ''}
                                </span>
                              );
                            else if (
                              itm?.publicprofilefieldid == 25 &&
                              itm.active == 0
                            )
                              return (
                                <span className="icon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="13.286"
                                    height="15.5"
                                    viewBox="0 0 13.286 15.5"
                                  >
                                    <defs>
                                      <style></style>
                                    </defs>
                                    <g transform="translate(-4.5 -2.25)">
                                      <path
                                        className="a"
                                        d="M15.571,8.893a2.214,2.214,0,0,1,2.214,2.214v4.429a2.214,2.214,0,0,1-2.214,2.214H6.714A2.214,2.214,0,0,1,4.5,15.536V11.107A2.214,2.214,0,0,1,6.714,8.893V6.679a4.429,4.429,0,1,1,8.857,0ZM11.143,3.726A2.952,2.952,0,0,1,14.1,6.679V8.893H8.19V6.679a2.952,2.952,0,0,1,2.952-2.952Zm4.429,6.643H6.714a.738.738,0,0,0-.738.738v4.429a.738.738,0,0,0,.738.738h8.857a.738.738,0,0,0,.738-.738V11.107A.738.738,0,0,0,15.571,10.369Z"
                                      />
                                    </g>
                                  </svg>
                                </span>
                              );
                          }
                        ) || ''
                      ) : (
                        <span style={{ color: '#c0321f' }}>
                          {athletePersonalInfo?.heightValue
                            ? athletePersonalInfo?.heightValue + "'"
                            : ''}
                          &nbsp;
                          {athletePersonalInfo?.heightInInches ||
                          athletePersonalInfo?.heightInInches === 0
                            ? `${athletePersonalInfo?.heightInInches}" `
                            : ''}
                          {!!athletePersonalInfo?.weight
                            ? `/ ${athletePersonalInfo?.weight}`
                            : ''}
                        </span>
                      )}
                    </div>
                  </div>

                  {commitmentInfo?.collegename ? (
                    <div className="item commmitBox">
                      <span className="label">Committed</span>
                      <span className="imgBox">
                        <img src={getCommittedLogo()} alt="" />
                      </span>
                      <span style={{ marginTop: 0 }}>
                        {getCommittedClgName(commitmentInfo?.collegename ?? '')}
                      </span>
                    </div>
                  ) : isPublicView ? (
                    <div className="item commmitBox uncommit">
                      <span className="label">UnCommitted</span>
                      <span style={{ marginTop: -6 }}>
                        Player has made a commitment?
                        <button
                          className="btn tell-us-btn"
                          onClick={() => popUpTellHandle()}
                        >
                          Tell us?
                        </button>
                      </span>
                    </div>
                  ) : (
                    <div className="item commmitBox uncommit">
                      <span className="label">UnCommitted</span>
                      <a
                        onClick={() => props.history.push('/viewCommitment')}
                        href={void 0}
                      >
                        <span style={{ marginTop: 15 }}>Add my commitment</span>
                      </a>
                    </div>
                  )}

                  <div
                    className="item"
                    style={!isShowMore ? { display: 'none' } : {}}
                  >
                    <div className="item-detail">
                      <span className="label">Bat / Throw</span>
                      <span style={{ color: '#c0321f' }}>
                        {!!athletePersonalInfo?.battingPreferenceValue
                          ? athletePersonalInfo?.battingPreferenceValue?.split(
                              ''
                            )[0]
                          : ''}{' '}
                        {!!athletePersonalInfo?.battingPreferenceValue &&
                        !!athletePersonalInfo?.throwingPreferenceValue
                          ? ' / '
                          : ''}
                        {!!athletePersonalInfo?.throwingPreferenceValue
                          ? athletePersonalInfo?.throwingPreferenceValue?.split(
                              ''
                            )[0]
                          : ''}
                      </span>
                    </div>
                  </div>
                  <div className="item gpaScore">
                    <div className="item-detail">
                      <span className="label">GPA (UW / W)</span>
                      {isPublicView ? (
                        isPremier?.athlete?.editUserProfileData?.getprofileTimelineStatusTabs?.data?.profileTimelineAbout?.map(
                          (itm, idx) => {
                            if (
                              itm?.publicprofilefieldid == 28 &&
                              itm.active == 1
                            ) {
                              return (
                                <span style={{ color: '#c0321f' }}>
                                  {/*{isPublicView}*/}
                                  {athletePersonalInfo &&
                                    !!athletePersonalInfo?.gpaScale &&
                                    !!athletePersonalInfo?.unweightedgpa &&
                                    `${athletePersonalInfo?.unweightedgpa} / ${athletePersonalInfo?.gpaScale}`}
                                  {athletePersonalInfo &&
                                    !athletePersonalInfo?.gpaScale &&
                                    !!athletePersonalInfo?.unweightedgpa &&
                                    `${athletePersonalInfo?.unweightedgpa}(UW)`}
                                  {athletePersonalInfo &&
                                    !!athletePersonalInfo?.gpaScale &&
                                    !athletePersonalInfo?.unweightedgpa &&
                                    `${athletePersonalInfo?.gpaScale}(W)`}
                                </span>
                              );
                            } else if (
                              itm?.publicprofilefieldid == 28 &&
                              itm.active == 0
                            ) {
                              return (
                                <span className="icon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="13.286"
                                    height="15.5"
                                    viewBox="0 0 13.286 15.5"
                                  >
                                    <defs>
                                      <style></style>
                                    </defs>
                                    <g transform="translate(-4.5 -2.25)">
                                      <path
                                        className="a"
                                        d="M15.571,8.893a2.214,2.214,0,0,1,2.214,2.214v4.429a2.214,2.214,0,0,1-2.214,2.214H6.714A2.214,2.214,0,0,1,4.5,15.536V11.107A2.214,2.214,0,0,1,6.714,8.893V6.679a4.429,4.429,0,1,1,8.857,0ZM11.143,3.726A2.952,2.952,0,0,1,14.1,6.679V8.893H8.19V6.679a2.952,2.952,0,0,1,2.952-2.952Zm4.429,6.643H6.714a.738.738,0,0,0-.738.738v4.429a.738.738,0,0,0,.738.738h8.857a.738.738,0,0,0,.738-.738V11.107A.738.738,0,0,0,15.571,10.369Z"
                                      />
                                    </g>
                                  </svg>
                                </span>
                              );
                            }
                          }
                        ) || ''
                      ) : (
                        <span style={{ color: '#c0321f' }}>
                          {/*{isPublicView}*/}
                          {athletePersonalInfo &&
                            !!athletePersonalInfo?.gpaScale &&
                            !!athletePersonalInfo?.unweightedgpa &&
                            `${athletePersonalInfo?.unweightedgpa} / ${athletePersonalInfo?.gpaScale}`}
                          {athletePersonalInfo &&
                            !athletePersonalInfo?.gpaScale &&
                            !!athletePersonalInfo?.unweightedgpa &&
                            `${athletePersonalInfo?.unweightedgpa}(UW)`}
                          {athletePersonalInfo &&
                            !!athletePersonalInfo?.gpaScale &&
                            !athletePersonalInfo?.unweightedgpa &&
                            `${athletePersonalInfo?.gpaScale}(W)`}
                        </span>
                      )}
                      <span className="infoIcon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17.999"
                          height="17.999"
                          viewBox="0 0 17.999 17.999"
                        >
                          <defs>
                            <style></style>
                          </defs>
                          <path
                            className="a"
                            d="M10.445,7.271a.846.846,0,0,1,.844-.844h.562a.846.846,0,0,1,.844.844v.562a.846.846,0,0,1-.844.844h-.562a.846.846,0,0,1-.844-.844Zm3.375,8.156H9.32V14.3h1.125V10.927H9.32V9.8h3.375v4.5H13.82Zm-2.25-13.5a9,9,0,1,0,9,9,9,9,0,0,0-9-9Zm0,16.311a7.312,7.312,0,1,1,7.312-7.312A7.312,7.312,0,0,1,11.57,18.239Z"
                            transform="translate(-2.571 -1.928)"
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                  <div className="item satAct">
                    <div className="item-detail">
                      <span className="label" style={{ marginTop: 0 }}>
                        SAT / ACT
                      </span>
                      {isPublicView ? (
                        isPremier?.athlete?.editUserProfileData?.getprofileTimelineStatusTabs?.data?.profileTimelineAbout?.map(
                          (itm, idx) => {
                            if (
                              itm?.publicprofilefieldid == 30 &&
                              itm?.active
                            ) {
                              return (
                                <span style={{ color: '#c0321f' }}>
                                  {' '}
                                  {athletePersonalInfo?.sattotalnumber
                                    ? athletePersonalInfo?.sattotalnumber.toLocaleString(
                                        'en-US',
                                        { maximumFractionDigits: 2 }
                                      )
                                    : ''}{' '}
                                  {athletePersonalInfo?.sattotalnumber &&
                                  athletePersonalInfo?.actcompositescoreValue
                                    ? ' / '
                                    : ''}
                                  {athletePersonalInfo?.actcompositescoreValue
                                    ? athletePersonalInfo?.actcompositescoreValue.toLocaleString(
                                        'en-US',
                                        { maximumFractionDigits: 2 }
                                      )
                                    : ''}
                                </span>
                              );
                            } else if (
                              itm?.publicprofilefieldid == 30 &&
                              itm?.active == 0
                            ) {
                              return (
                                <span className="icon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="13.286"
                                    height="15.5"
                                    viewBox="0 0 13.286 15.5"
                                  >
                                    <defs>
                                      <style></style>
                                    </defs>
                                    <g transform="translate(-4.5 -2.25)">
                                      <path
                                        className="a"
                                        d="M15.571,8.893a2.214,2.214,0,0,1,2.214,2.214v4.429a2.214,2.214,0,0,1-2.214,2.214H6.714A2.214,2.214,0,0,1,4.5,15.536V11.107A2.214,2.214,0,0,1,6.714,8.893V6.679a4.429,4.429,0,1,1,8.857,0ZM11.143,3.726A2.952,2.952,0,0,1,14.1,6.679V8.893H8.19V6.679a2.952,2.952,0,0,1,2.952-2.952Zm4.429,6.643H6.714a.738.738,0,0,0-.738.738v4.429a.738.738,0,0,0,.738.738h8.857a.738.738,0,0,0,.738-.738V11.107A.738.738,0,0,0,15.571,10.369Z"
                                      />
                                    </g>
                                  </svg>
                                </span>
                              );
                            }
                          }
                        ) || ''
                      ) : (
                        <span style={{ color: '#c0321f' }}>
                          {' '}
                          {athletePersonalInfo?.sattotalnumber
                            ? athletePersonalInfo?.sattotalnumber.toLocaleString(
                                'en-US',
                                { maximumFractionDigits: 2 }
                              )
                            : ''}{' '}
                          {athletePersonalInfo?.sattotalnumber &&
                          athletePersonalInfo?.actcompositescoreValue
                            ? ' / '
                            : ''}
                          {athletePersonalInfo?.actcompositescoreValue
                            ? athletePersonalInfo?.actcompositescoreValue.toLocaleString(
                                'en-US',
                                { maximumFractionDigits: 2 }
                              )
                            : ''}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="item rating">
                    <div className="item-detail">
                      <span className="label">Rating</span>
                      <span className="lockIcon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="13.286"
                          height="15.5"
                          viewBox="0 0 13.286 15.5"
                        >
                          <defs>
                            <style></style>
                          </defs>
                          <g transform="translate(-4.5 -2.25)">
                            <path
                              className="a"
                              d="M15.571,8.893a2.214,2.214,0,0,1,2.214,2.214v4.429a2.214,2.214,0,0,1-2.214,2.214H6.714A2.214,2.214,0,0,1,4.5,15.536V11.107A2.214,2.214,0,0,1,6.714,8.893V6.679a4.429,4.429,0,1,1,8.857,0ZM11.143,3.726A2.952,2.952,0,0,1,14.1,6.679V8.893H8.19V6.679a2.952,2.952,0,0,1,2.952-2.952Zm4.429,6.643H6.714a.738.738,0,0,0-.738.738v4.429a.738.738,0,0,0,.738.738h8.857a.738.738,0,0,0,.738-.738V11.107A.738.738,0,0,0,15.571,10.369Z"
                            />
                          </g>
                        </svg>
                      </span>
                      <span className="infoIcon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17.999"
                          height="17.999"
                          viewBox="0 0 17.999 17.999"
                        >
                          <defs>
                            <style></style>
                          </defs>
                          <path
                            className="a"
                            d="M10.445,7.271a.846.846,0,0,1,.844-.844h.562a.846.846,0,0,1,.844.844v.562a.846.846,0,0,1-.844.844h-.562a.846.846,0,0,1-.844-.844Zm3.375,8.156H9.32V14.3h1.125V10.927H9.32V9.8h3.375v4.5H13.82Zm-2.25-13.5a9,9,0,1,0,9,9,9,9,0,0,0-9-9Zm0,16.311a7.312,7.312,0,1,1,7.312-7.312A7.312,7.312,0,0,1,11.57,18.239Z"
                            transform="translate(-2.571 -1.928)"
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                  <div className="showhideBox">
                    <a
                      href={void 0}
                      onClick={() => setAIsShowMore(!isShowMore)}
                    >
                      <span className="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="8"
                          height="4"
                          viewBox="0 0 8 4"
                        >
                          <defs>
                            <style></style>
                          </defs>
                          <path
                            className="a"
                            d="M4,0,8,4H0Z"
                            transform="translate(8 4) rotate(180)"
                          ></path>
                        </svg>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
              <div className={`actionBox ${expand ? 'show' : ''}`}>
                {/* <Tooltip placement="top" title={isPublicView ? getFollowStatus(athletePersonalInfo) : "Edit"} arrow> */}
                {!isPublicView ? (
                  <Tooltip
                    placement="top"
                    title={
                      isPublicView
                        ? getFollowStatus(athletePersonalInfo)
                        : 'Edit'
                    }
                    arrow
                  >
                    <div>
                      <button
                        className="promoteBtn"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Edit"
                        data-original-title="Edit"
                        style={
                          getCheckStatus()
                            ? {}
                            : { display: 'none', width: '120px' }
                        }
                        onClick={(e) => {
                          !isPublicView
                            ? EditButton(e)
                            : // userProfileApi({obj: {userrole: "ATHLETES", profileviewedby: getUserInfo()?.id ?? 0, profileviewto: +pubViewID || 0}}, true, false)
                              console.log('isPublicView', isPublicView);
                        }}
                      >
                        <span className="icon">
                          {isPublicView ? (
                            getFollowStatus(athletePersonalInfo) ===
                            'Follow' ? (
                              <span
                                onClick={() =>
                                  isPublicView &&
                                  athleteFollowApi(
                                    getUserInfo()?.id ?? 0,
                                    +pubViewID || 0,
                                    true,
                                    getFollowStatus(athletePersonalInfo)
                                  ) &&
                                  setTimeout(() => {
                                    setRenderCount(renderCount + 1);
                                  }, 500)
                                }
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  id="Group_392"
                                  data-name="Group 392"
                                  width="23.66"
                                  height="18"
                                  viewBox="0 0 23.66 18"
                                >
                                  <path
                                    id="Path_151"
                                    data-name="Path 151"
                                    d="M329.452,3.546h-3.019V.662a.694.694,0,0,0-1.386,0V3.546h-3.019a.663.663,0,1,0,0,1.324h3.019V7.755a.694.694,0,0,0,1.386,0V4.871h3.019a.663.663,0,1,0,0-1.324Z"
                                    transform="translate(-306.485)"
                                    fill="#fff"
                                  />
                                  <path
                                    id="Path_152"
                                    data-name="Path 152"
                                    d="M8.118,321.334A7.952,7.952,0,0,0,0,329.089a.678.678,0,0,0,.693.662H15.542a.678.678,0,0,0,.693-.662A7.952,7.952,0,0,0,8.118,321.334Z"
                                    transform="translate(0 -311.751)"
                                    fill="#fff"
                                  />
                                  <path
                                    id="Path_153"
                                    data-name="Path 153"
                                    d="M84.739,64.267a4.213,4.213,0,1,0,4.405,4.209A4.315,4.315,0,0,0,84.739,64.267Z"
                                    transform="translate(-76.622 -64.267)"
                                    fill="#fff"
                                  />
                                </svg>
                              </span>
                            ) : (
                              <span
                                onClick={() =>
                                  isPublicView &&
                                  athleteFollowApi(
                                    getUserInfo()?.id ?? 0,
                                    +pubViewID || 0,
                                    true,
                                    getFollowStatus(athletePersonalInfo)
                                  ) &&
                                  setTimeout(() => {
                                    setRenderCount(renderCount + 1);
                                  }, 500)
                                }
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlnsXlink="http://www.w3.org/1999/xlink"
                                  width="23.66"
                                  height="18"
                                  viewBox="0 0 23.66 18"
                                >
                                  <defs>
                                    <clipPath id="clip">
                                      <use xlinkHref="#fill" />
                                    </clipPath>
                                  </defs>
                                  <g
                                    id="Group_57463"
                                    data-name="Group 57463"
                                    transform="translate(461 12215)"
                                  >
                                    <g id="Group_57462" data-name="Group 57462">
                                      <path
                                        id="Path_152"
                                        data-name="Path 152"
                                        d="M8.118,321.334A7.952,7.952,0,0,0,0,329.089a.678.678,0,0,0,.693.662H15.542a.678.678,0,0,0,.693-.662A7.952,7.952,0,0,0,8.118,321.334Z"
                                        transform="translate(-461 -12526.751)"
                                        fill="#fff"
                                      />
                                      <path
                                        id="Path_153"
                                        data-name="Path 153"
                                        d="M84.739,64.267a4.213,4.213,0,1,0,4.405,4.209A4.315,4.315,0,0,0,84.739,64.267Z"
                                        transform="translate(-537.622 -12279.267)"
                                        fill="#fff"
                                      />
                                    </g>
                                    <g
                                      id="Rectangle_11874"
                                      data-name="Rectangle 11874"
                                      transform="translate(-437.34 -12211.791) rotate(90)"
                                      fill="none"
                                      stroke="#fff"
                                      stroke-width="6"
                                    >
                                      <rect
                                        id="fill"
                                        width="1.3"
                                        height="8"
                                        rx="0.65"
                                        stroke="none"
                                      />
                                      <path
                                        d="M0,3h1.2999999523162842M3,0v8M1.2999999523162842,5h-1.2999999523162842M-1.7000000476837158,8v-8"
                                        fill="none"
                                        clip-path="url(#clip)"
                                      />
                                    </g>
                                  </g>
                                </svg>
                              </span>
                            )
                          ) : (
                            <>
                              {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                             width="24.001"
                             height="18.943"
                             viewBox="0 0 24.001 18.943"
                         >
                           <defs>
                             <style></style>
                           </defs>
                           <path
                               className="a"
                               d="M11.947,14.207l1.56-1.56L11.462,10.6,9.9,12.161v.753h1.292v1.292h.753ZM17.866,4.52a.278.278,0,0,0-.444.013L12.713,9.242a.305.305,0,1,0,.431.431l4.709-4.709a.278.278,0,0,0,.013-.444Zm1.076,7.991v2.556a3.882,3.882,0,0,1-3.874,3.875H3.875a3.73,3.73,0,0,1-2.738-1.137A3.735,3.735,0,0,1,0,15.068V3.875A3.73,3.73,0,0,1,1.137,1.137,3.735,3.735,0,0,1,3.875,0H15.068a3.7,3.7,0,0,1,1.574.336.41.41,0,0,1,.242.309.42.42,0,0,1-.121.39l-.659.659a.394.394,0,0,1-.431.108,2.384,2.384,0,0,0-.605-.081H3.875a2.073,2.073,0,0,0-1.52.632,2.073,2.073,0,0,0-.632,1.52V15.067a2.073,2.073,0,0,0,.632,1.52,2.073,2.073,0,0,0,1.52.632H15.068a2.158,2.158,0,0,0,2.152-2.152V13.373a.4.4,0,0,1,.121-.3l.861-.861a.4.4,0,0,1,.471-.094.39.39,0,0,1,.269.39ZM17.65,2.583l3.875,3.875L12.484,15.5H8.61V11.624Zm5.974,1.776L22.386,5.6,18.511,1.722,19.749.484a1.3,1.3,0,0,1,1.83,0l2.045,2.045A1.246,1.246,0,0,1,24,3.444a1.246,1.246,0,0,1-.377.915Z"
                           />
                         </svg> */}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="19"
                                viewBox="0 0 24 19"
                              >
                                <path
                                  id="edit"
                                  d="M11.946,14.25l1.56-1.565-2.045-2.051L9.9,12.2v.756h1.292v1.3h.753Zm5.919-9.716a.278.278,0,0,0-.444.013L12.713,9.27a.305.305,0,1,0,.431.432l4.708-4.723a.279.279,0,0,0,.013-.445Zm1.076,8.016v2.564A3.888,3.888,0,0,1,15.067,19H3.875a3.725,3.725,0,0,1-2.738-1.141A3.752,3.752,0,0,1,0,15.113V3.887A3.747,3.747,0,0,1,1.137,1.141,3.73,3.73,0,0,1,3.875,0H15.067a3.689,3.689,0,0,1,1.574.337.411.411,0,0,1,.242.31.422.422,0,0,1-.121.392L16.1,1.7a.393.393,0,0,1-.431.108,2.377,2.377,0,0,0-.605-.081H3.875a2.069,2.069,0,0,0-1.52.634,2.082,2.082,0,0,0-.632,1.525V15.113a2.082,2.082,0,0,0,.632,1.525,2.069,2.069,0,0,0,1.52.634H15.067a2.162,2.162,0,0,0,2.152-2.159v-1.7a.4.4,0,0,1,.121-.3l.861-.864a.4.4,0,0,1,.471-.095.391.391,0,0,1,.269.392ZM17.65,2.591l3.875,3.887-9.04,9.068H8.61V11.659Zm5.973,1.781L22.385,5.613,18.511,1.727,19.748.486a1.3,1.3,0,0,1,1.83,0l2.045,2.051A1.251,1.251,0,0,1,24,3.455,1.251,1.251,0,0,1,23.623,4.372Z"
                                  fill="#fff"
                                />
                              </svg>
                            </>
                          )}
                        </span>
                        {/* <span
                    onClick={() =>
                      isPublicView &&
                      athleteFollowApi(
                        getUserInfo()?.id ?? 0,
                        +pubViewID || 0,
                        true,
                        getFollowStatus(athletePersonalInfo)
                      ) &&
                      setTimeout(() => {
                        setRenderCount(renderCount + 1);
                      }, 500)
                    }
                  >
                  </span> */}
                      </button>
                    </div>
                  </Tooltip>
                ) : (
                  ''
                )}
                {getCP() && (
                  <Tooltip placement="top" title={'Claim Profile'} arrow>
                    <button
                      type={'button'}
                      className="claim-profile-btn"
                      onClick={() => {
                        handelClaimProfile();
                      }}
                    >
                      <span className="icon">
                        <svg
                          id="__TEMP__SVG__"
                          xmlns="http://www.w3.org/2000/svg"
                          width="23.999"
                          height="23.999"
                          viewBox="0 0 23.999 23.999"
                        >
                          <path
                            id="Path_2292"
                            data-name="Path 2292"
                            d="M24,12A12,12,0,1,1,12,0,12,12,0,0,1,24,12ZM18.044,7.455a1.125,1.125,0,0,0-1.62.033l-5.209,6.637L8.076,10.984a1.125,1.125,0,0,0-1.59,1.59l3.969,3.97a1.125,1.125,0,0,0,1.619-.03l5.988-7.485a1.125,1.125,0,0,0-.015-1.575Z"
                            fill="#fff"
                            fill-rule="evenodd"
                          />
                        </svg>
                      </span>
                      Claim Profile
                    </button>
                  </Tooltip>
                )}
                <Tooltip placement="top" title={'Share'} arrow>
                  <button className="followBtn">
                    <span className="icon" onClick={() => setIsShare(!isShare)}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="19.995"
                        viewBox="0 0 24 19.995"
                      >
                        <path
                          id="Icon_ionic-ios-share-alt"
                          data-name="Icon ionic-ios-share-alt"
                          d="M28.289,15.148,19.472,6.9a.451.451,0,0,0-.35-.15c-.275.012-.625.206-.625.5v4.137a.267.267,0,0,1-.225.256c-8.767,1.343-12.46,7.9-13.766,14.716-.05.269.312.519.481.306,3.2-4.03,7.092-6.661,13.247-6.711a.309.309,0,0,1,.262.3v4.062a.536.536,0,0,0,.906.331l8.88-8.392a.69.69,0,0,0,.219-.525A.837.837,0,0,0,28.289,15.148Z"
                          transform="translate(-4.502 -6.749)"
                          fill="#fff"
                        />
                      </svg>
                      {/*<svg*/}
                      {/*  xmlns="http://www.w3.org/2000/svg"*/}
                      {/*  width="14"*/}
                      {/*  height="15.458"*/}
                      {/*  viewBox="0 0 14 15.458"*/}
                      {/*>*/}
                      {/*  <defs>*/}
                      {/*    <style></style>*/}
                      {/*  </defs>*/}
                      {/*  <path*/}
                      {/*    className="a"*/}
                      {/*    d="M16.16,14.047a2.125,2.125,0,0,0-1.521.583L9.063,11.406a2.612,2.612,0,0,0,.078-.544,2.61,2.61,0,0,0-.078-.544l5.5-3.185a2.334,2.334,0,1,0-.741-1.709,2.6,2.6,0,0,0,.078.544L8.4,9.153a2.347,2.347,0,0,0-1.6-.621,2.309,2.309,0,0,0-2.3,2.33,2.348,2.348,0,0,0,3.939,1.709l5.538,3.224a1.948,1.948,0,0,0-.078.5,2.262,2.262,0,1,0,2.262-2.253Z"*/}
                      {/*    transform="translate(-4.5 -3.094)"*/}
                      {/*  />*/}
                      {/*</svg>*/}
                      {/* <span style={{ marginLeft: "8px" }}>Share</span> */}
                    </span>
                    <span></span>
                  </button>
                </Tooltip>
                {getClaimStatus() && (
                  <Tooltip placement="top" title={'Claim Profile'} arrow>
                    <button
                      className="claim-profile-btn"
                      onClick={() => {
                        setIsClaimPop(true);
                      }}
                    >
                      <span className="icon">
                        <svg
                          id="__TEMP__SVG__"
                          xmlns="http://www.w3.org/2000/svg"
                          width="23.999"
                          height="23.999"
                          viewBox="0 0 23.999 23.999"
                        >
                          <path
                            id="Path_2292"
                            data-name="Path 2292"
                            d="M24,12A12,12,0,1,1,12,0,12,12,0,0,1,24,12ZM18.044,7.455a1.125,1.125,0,0,0-1.62.033l-5.209,6.637L8.076,10.984a1.125,1.125,0,0,0-1.59,1.59l3.969,3.97a1.125,1.125,0,0,0,1.619-.03l5.988-7.485a1.125,1.125,0,0,0-.015-1.575Z"
                            fill="#fff"
                            fill-rule="evenodd"
                          />
                        </svg>
                      </span>
                      Claim Profile
                    </button>
                  </Tooltip>
                )}
                {getAuthToken() && !isPublicView && (
                  <Tooltip placement="top" title={'Privacy Settings'} arrow>
                    <button className="privacyBtn">
                      <span
                        className="icon"
                        onClick={() => setIsActive(!isActive)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="19.995"
                          viewBox="0 0 23.95 23.95"
                        >
                          <g id="gear-fill" transform="translate(0.001 0)">
                            <path
                              id="Path_2289"
                              data-name="Path 2289"
                              d="M14.078,1.572a2.193,2.193,0,0,0-4.206,0l-.15.509A2.191,2.191,0,0,1,6.572,3.386l-.464-.255A2.193,2.193,0,0,0,3.133,6.106l.253.466A2.191,2.191,0,0,1,2.08,9.723l-.509.15a2.193,2.193,0,0,0,0,4.206l.509.15a2.191,2.191,0,0,1,1.305,3.151l-.255.464a2.193,2.193,0,0,0,2.974,2.974l.466-.253A2.191,2.191,0,0,1,9.722,21.87l.15.509a2.193,2.193,0,0,0,4.206,0l.15-.509a2.191,2.191,0,0,1,3.151-1.305l.464.255a2.193,2.193,0,0,0,2.974-2.974l-.253-.466a2.191,2.191,0,0,1,1.305-3.151l.509-.15a2.193,2.193,0,0,0,0-4.206l-.509-.15a2.191,2.191,0,0,1-1.305-3.151l.255-.464a2.193,2.193,0,0,0-2.974-2.974l-.466.253a2.191,2.191,0,0,1-3.151-1.305l-.15-.509Zm-2.1,14.789a4.386,4.386,0,1,0-4.384-4.388,4.386,4.386,0,0,0,4.384,4.388Z"
                              transform="translate(0)"
                              fill="#fff"
                              fill-rule="evenodd"
                            />
                          </g>
                        </svg>
                      </span>
                      <span></span>
                    </button>
                  </Tooltip>
                )}
                {getAuthToken() && !isPublicView ? (
                  <button
                    type={'button'}
                    className="menuBtn"
                    // onClick={() => handleCollapseExpand()} //this is commented as per aug 2022 task
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <Tooltip title={'Public Profile'} placement={'top'}>
                      <Link
                        className=""
                        style={{ cursor: 'pointer' }}
                        // to={`/publicView/1/${getUserInfo()?.id || 0}`}
                        // to={`/publicView/0/${athletePersonalInfo?.userId || 0}`}// route 18/4/2023
                        to={`/${getAthleteSysID()}`}
                        target="_blank"
                        onClick={() => {
                          // setExpand(!expand);
                          setIsActive(false);
                          setIsTab(isTab + 1);
                          localStorage.setItem(
                            'pubViewID',
                            getUserInfo()?.id || 0
                          );
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 34 34.001"
                          fill={'#1CB79E'}
                        >
                          <path
                            fill={'#fff'}
                            d="M-4214-6658h-30a2,2,0,0,1-2-2v-30a2,2,0,0,1,2-2h30a2,2,0,0,1,2,2v30A2,2,0,0,1-4214-6658Zm-19-13a7.008,7.008,0,0,0-7,7l0,1h22v-1a7.008,7.008,0,0,0-7-7Zm4-16a6.006,6.006,0,0,0-6,6,6.007,6.007,0,0,0,6,6,6.007,6.007,0,0,0,6-6A6.006,6.006,0,0,0-4229-6687Z"
                            transform="translate(4246 6692)"
                          />
                        </svg>
                      </Link>
                    </Tooltip>
                    {/*below svg icon is commented as per aug 2022 task */}
                    {/*<span className="icon">*/}
                    {/*  <svg xmlns="http://www.w3.org/2000/svg" width="5" height="20" viewBox="0 0 5 20">*/}
                    {/*    <path id="bx-dots-vertical-rounded" d="M17.5,13.5A2.5,2.5,0,1,0,20,16,2.507,2.507,0,0,0,17.5,13.5Zm0-7.5A2.5,2.5,0,1,0,20,8.5,2.507,2.507,0,0,0,17.5,6Zm0,15A2.5,2.5,0,1,0,20,23.5,2.507,2.507,0,0,0,17.5,21Z" transform="translate(-15 -6)" fill="#fff" />*/}
                    {/*  </svg>*/}
                    {/*</span>*/}
                  </button>
                ) : null}
                <div
                  className={`dropdown-menu ${expand ? 'show' : ''}`}
                  // aria-labelledby="dropdownMenuButton"
                >
                  <a
                    className="dropdown-item"
                    style={{ cursor: 'pointer' }}
                    onClick={() => props.history.push('/viewCommitment')}
                  >
                    <span className="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="23.973"
                        height="19"
                        viewBox="0 0 23.973 19"
                      >
                        <defs>
                          <style></style>
                        </defs>
                        <g transform="translate(0 0)">
                          <path
                            className="a"
                            d="M0,7.74a2.152,2.152,0,0,0,1.4,2.04V5.9c0-.056.028-.14.028-.2A2.179,2.179,0,0,0,0,7.74Z"
                            transform="translate(0 0.196)"
                          />
                          <path
                            className="a"
                            d="M6.358,10.355H2.7l1.369,4.973a1.732,1.732,0,0,0,1.676,1.285,1.76,1.76,0,0,0,1.425-.7,1.62,1.62,0,0,0,.279-1.509Z"
                            transform="translate(1.27 2.386)"
                          />
                          <path
                            className="a"
                            d="M.969,5.69H1V5.662C1,5.69,1,5.69.969,5.69Z"
                            transform="translate(0.456 0.178)"
                          />
                          <path
                            className="a"
                            d="M14.663,5.415H14.44v5.029h.224a2.515,2.515,0,0,0,0-5.029Z"
                            transform="translate(6.795 0.062)"
                          />
                          <path
                            className="a"
                            d="M1.52,6.387v3.968A1.9,1.9,0,0,0,3.42,12.2H8.505V4.655H3.42A1.817,1.817,0,0,0,1.52,6.387Z"
                            transform="translate(0.715 -0.296)"
                          />
                          <path
                            className="a"
                            d="M6.84,13.706l10.338,4.135V1.691L6.84,5.826Z"
                            transform="translate(3.219 -1.691)"
                          />
                        </g>
                      </svg>
                    </span>
                    <span>Announce Commitment</span>
                  </a>
                  <Link
                    className="dropdown-item"
                    style={{ cursor: 'pointer' }}
                    // to={`/publicView/1/${getUserInfo()?.id || 0}`}
                    to={`/publicView/0/${athletePersonalInfo?.userId || 0}`}
                    target="_blank"
                    onClick={() => {
                      setExpand(!expand);
                      setIsActive(false);
                      setIsTab(isTab + 1);
                      localStorage.setItem('pubViewID', getUserInfo()?.id || 0);
                      //////
                      // window.open(
                      //   `${prod}publicView/1/${getUserInfo().id || 0}`,
                      //   "_blank",
                      //   "noopener,noreferrer"
                      // );
                      //////
                      // history.push('/publicProfile')
                    }}
                  >
                    <span className="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12.008"
                        height="13.414"
                        viewBox="0 0 12.008 13.414"
                      >
                        <defs>
                          <style></style>
                        </defs>
                        <g transform="translate(-24.165)">
                          <g transform="translate(26.687)">
                            <path
                              className="a"
                              d="M114.274,0a3.483,3.483,0,1,0,3.483,3.483A3.492,3.492,0,0,0,114.274,0Z"
                              transform="translate(-110.791)"
                            />
                          </g>
                          <g transform="translate(24.165 7.215)">
                            <path
                              className="a"
                              d="M36.147,250.375a3.248,3.248,0,0,0-.35-.639,4.329,4.329,0,0,0-3-1.886.641.641,0,0,0-.441.106,3.713,3.713,0,0,1-4.38,0,.571.571,0,0,0-.441-.106,4.3,4.3,0,0,0-3,1.886,3.744,3.744,0,0,0-.35.639.323.323,0,0,0,.015.289,6.071,6.071,0,0,0,.411.608,5.78,5.78,0,0,0,.7.791,9.123,9.123,0,0,0,.7.608,6.936,6.936,0,0,0,8.274,0,6.687,6.687,0,0,0,.7-.608,7.025,7.025,0,0,0,.7-.791,5.333,5.333,0,0,0,.411-.608A.26.26,0,0,0,36.147,250.375Z"
                              transform="translate(-24.165 -247.841)"
                            />
                          </g>
                        </g>
                      </svg>
                    </span>
                    <span>View my public profile</span>
                  </Link>
                </div>
              </div>
              <div className="metricCarouselBox">
                {isPublicView ? (
                  isPremier?.athlete?.editUserProfileData?.getprofileTimelineStatusTabs?.data?.profileTimelineAbout?.map(
                    (itm, idx) => {
                      if (
                        itm?.publicprofilefieldid == 27 &&
                        itm?.active == 1 &&
                        statMatrixData?.length > 0
                      ) {
                        return (
                          <>
                            <h5 className="title">Metrics</h5>
                            {/*<div className="metricCarousel owl-carousel"></div>*/}
                            <MetricsCarousel statMatrixData={statMatrixData} />
                          </>
                        );
                      }
                    }
                  )
                ) : statMatrixData?.length > 0 ? (
                  <>
                    <h5 className="title">Metrics</h5>
                    <MetricsCarousel statMatrixData={statMatrixData} />
                  </>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        ) : (
          ''
        )}

        <GoTopButton
          goTop={() => {
            goTop();
          }}
        />
      </div>
      <div className="athleteProfileFinalDarkSection mt-0">
        {!isAthleteRemoved ? (
          <div className="bottomSection">
            <ProfileTabs
              isActive={isActive}
              isPublicView={isPublicView}
              isTab={isTab}
              props={props}
              checkAthleteRemoveToken={checkAthleteRemoveToken}
            />
          </div>
        ) : (
          ''
        )}
        {getCP() && (
          <>
            <div className="actionBox">
              <button
                className="yesClaimProfileBtn"
                onClick={() => {
                  handelClaimProfile();
                }}
              >
                <span>Claim Profile</span>
              </button>
            </div>
            <div className={'actionBox'} style={{ marginRight: '10px' }}>
              <Link target="_blank" to={'/getscouted'} className="noBtn">
                {/*earlier it was redirecting to claimprofilestep1*/}
                <span style={{ color: '#c0321f' }}>Learn More</span>
              </Link>
            </div>
          </>
        )}
        {confirmModal && (
          <AreYouSure athleteID={Athid} confirmModal={setConfirmModal} />
        )}
      </div>
    </Root>
  );
};

const mapStateToProps = (state) => {
  return {
    athleteData: state.common.athletesData,
    allCountries: state.common.countries,
    athleteProfileData: state.athlete.profile.athleteProfileData,
    allProfileCalculationData: state.common.profileCalculationData,
    checkListData: state.common.checkListData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    countryListStart: (data) => dispatch(countryListStart(data)),
    checkListDataStart: (data) => dispatch(allCheckListDataStart(data)),
    athleteProfileDataStart: (data) => dispatch(athleteProfileDataStart(data)),
    profileCalculationListStart: (data) =>
      dispatch(allProfileCalculationListStart(data)),
    matchotpStart: (data) => dispatch(matchotpStart(data)),
    athleteListStart: (data) => dispatch(athletesDetailsStart(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DarkEditProfile);
